import angular from "angular";

import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import teams from "../../services/teams.js";
import companies from "../../services/companies.js";
import env from "../../services/env.js";
import security from "../../services/security.js";
import events from "../../services/events.js";

class PosteventController {
  constructor(
    $http,
    $localStorage,
    $state,
    $stateParams,
    AuthService,
    EnvService,
    TeamsService,
    CompaniesService,
    SecurityService,
    $filter,
    EventsService,
    $timeout,
    $location,
    $rootScope,
    $scope,
    TrackingService
  ) {
    this.name = "postevent";

    $localStorage.activeStateName = "postevent";
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$scope = $scope;
    this.$env = EnvService;
    this.$location = $location;
    this.$rootScope = $rootScope;
    this.$teams = TeamsService;
    this.$companies = CompaniesService;
    this.$security = SecurityService;
    this.$filter = $filter;
    this.$stateParams = $stateParams;
    this.$events = EventsService;
    this.shiftIsBeingEdited = false;
    this.$timeout = $timeout;
    this.showAllShifts = false;
    this.currentUser = this.$auth.getUserData();
    this.timeIntervalsArrayTemp = [];
    this.isClone = null;
    this.logo = null;
    this.ismarketing = false;
    this.googleIsDoneLoading = false;
    this.gtmData = null;
    this.arrayOfStatus = [];
    this.postType = "regular";
    this.isSourcingPost = false;
    this.saving = false;
    this.step = 0;
    this.sessionObj = {};
    this.tempEventHolderForSwitchingDuringClones = [];
    this.event_types = [];
    this.blockShiftClone = false;
    this.event_type = "";
    this.draftHasBeenCreated = false;
    this.jobble_types = [];
    this.teams = [];
    this.openingsList = {value: 1, values: []};
    this.postOptions = {
      value: "On-demand",
      values: ["On-demand", "Sourcing"],
    };
    this.mapsKey = null;
    this.postingLink = false;
    this.displaySelectACloudError = false;
    this.$tracking = TrackingService;
    this.currentAction = "";
    this.setPaymentPlan();
    this.googleMapKey = this.$auth.$env.EnvironmentConfig.mapsKey;
    this.fullGoogleUrl = "https://maps.googleapis.com/maps/api/js?libraries=places&key=" + this.googleMapKey;
    this.remain_loading_count = 1;
    this.displayFirstPageErrorMessage = false;
    this.tracker = {
      currentStep: 0,
      previousStep: null,
      nextStep: null,
      arrayOfVistedSteps: [0],
    };
    this.hasbeenvisited = [0];
    this.prevStep = 0;
    this.state = ["California", "Arizona"];
    this.states = ["Alaska", "Arizona", "Arkansas", "California"];
    this.setPostTypeInit();
    this.checkForAdmin();
    this.checkGoogle();
    this.statusBarStatus = {
      step_2: {
        visited: false,
        bar_class: "app-progress-bar",
        dot_class: "select",
      },
      step_3: {
        visited: false,
        bar_class: "app-progress-bar",
        dot_class: "select",
      },
      step_4: {
        visited: false,
        bar_class: "app-progress-bar",
        dot_class: "select",
      },
      step_5: {
        visited: false,
        bar_class: "app-progress-bar",
        dot_class: "select",
      },
    };

    this.check_for_state_params();

    //this.postEventLink();

    this.event = {
      name: "",
      event_type: 1,
      jobble_type: "",
      jobble_type_name: "",
      dress_code: null,
      hourly_rate: "",
      openings: 1,
      manager: null,
      jobble_details: null,
      postIsPrivate: false,
      cloudsForJobblePost: [],
      timeIntervalsArray: [
        {
          address: "",
          start_date: "",
          start_time: "",
          hours: "",
          minutes: "",
          posting_duration: "",
        },
      ],
    };

    //this.event={"name":"Test","event_type":1,"jobble_type":4,"jobble_type_name":"","dress_code":"Casual","hourly_rate":"25","openings":1,"manager":4519,"jobble_details":"Test","postIsPrivate":false,"cloudsForJobblePost":[],"timeIntervalsArray":[{"address":"","start_date":"","start_time":"","hours":"","minutes":"","posting_duration":""}],"hourly_rate_adj":"20.00"}

    console.log("current user");
    console.dir(this.currentUser);

    this.currentTimeInterval = this.event.timeIntervalsArray[0];

    var _this = this;

    for (var i = 0; i < 500; i++) {
      _this.openingsList.values.push(i + 1);
    }

    _this.$timeout(function () {
      jQuery("#modal-post-your-event").trigger("click");
    });

    if (this.$rootScope.jobble_types) {
      _this.jobble_types = this.$rootScope.jobble_types;
      _this.$auth.getJobbleTypes().then(function (data) {
        _this.jobble_types = data.data;
      });
      if (_this.$location.$$search.eid) {
        var tempTimeArray = [];
        _this.isClone = true;
        _this.$timeout(function () {
          _this.$rootScope.$emit("SetLoaderDialog", {
            type: 12,
            total: 1,
          });
        });
        _this.remain_loading_count = 1;
        _this.$events.getEventByIdTrimmed(_this.$location.$$search.eid, 1).then(function (eventResp) {
          _this.eventResponse = eventResp.data;
          _this.event.isClone = true;
          if (_this.eventResponse.isSourcingPost) {
            _this.postType = "source";
            _this.event.isSourcingPost = true;
            _this.isSourcingPost = true;
          } else {
            _this.postType = "regular";
            _this.event.isSourcingPost = false;
            _this.isSourcingPost = false;
          }
          try {
            eventResp.data.subEvents[0].deduppedJobbles[0].shifts.forEach(function (shift) {
              var tempTimeObj = {};
              tempTimeObj.contactInfo = {};
              tempTimeObj.address =
                shift.contactInfo.streetLine1 + " " + shift.contactInfo.city + " " + shift.contactInfo.state + " " + shift.contactInfo.zipCode;
              tempTimeObj.start_time = moment(shift.timeInterval.startTime).tz(shift.contactInfo.place.timeZoneId).format("hh:mm A");
              tempTimeObj.start_date = moment(shift.timeInterval.startTime).tz(shift.contactInfo.place.timeZoneId).format("MMM DD, YYYY");
              tempTimeObj.contactInfo.streetLine1 = shift.contactInfo.streetLine1;
              tempTimeObj.contactInfo.state = shift.contactInfo.state;
              tempTimeObj.contactInfo.city = shift.contactInfo.city;
              tempTimeObj.contactInfo.zipCode = shift.contactInfo.zipCode;
              tempTimeObj.contactInfo.lat = shift.contactInfo.lat;
              tempTimeObj.contactInfo.lng = shift.contactInfo.lng;
              var diffmin = moment(shift.timeInterval.endTime).diff(shift.timeInterval.startTime, "minutes");
              var diffhour = Math.floor(diffmin / 60);
              tempTimeObj.hours = diffhour;
              tempTimeObj.minutes = diffmin % 60;
              tempTimeArray.push(tempTimeObj);
            });
          } finally {
            _this.event.timeIntervalsArray = tempTimeArray;
            _this.event.name = eventResp.data.name;
            _this.event.dress_code = eventResp.data.subEvents[0].deduppedJobbles[0].dressCode;
            _this.event.hourly_rate = (eventResp.data.subEvents[0].deduppedJobbles[0].payPerHour / 100).toString();
            _this.calcNumbers();
            _this.openingsList.value = eventResp.data.numberOfOpenings + eventResp.data.numberOfApprovedApplications;
            _this.event.openings = _this.openingsList.value;
            _this.event.jobble_details = eventResp.data.description;
            _this.event.event_type = eventResp.data.eventTypeId;
            _this.event.jobble_type = eventResp.data.subEvents[0].deduppedJobbles[0].jobbleType.id;
            _this.event.postIsPrivate = false;
            _this.step = 0;
            _this.event.cloudsForJobblePost = [];
            _this.remain_loading_count = 0;
            _this.determineIfPublished(eventResp);
            _this.determineIfPrivate(eventResp);
            _this.determineJobbleType();
            if (eventResp.data.subEvents[0].deduppedJobbles[0].manager) {
              let manager_id = eventResp.data.subEvents[0].deduppedJobbles[0].manager.id;
              _this.event.manager = manager_id;
              _this.$timeout(function () {
                _this.$rootScope.$emit("SetManagerFromBack", {
                  id: _this.event.manager,
                });
              });
            }
            _this.$timeout(function () {
              _this.$rootScope.$emit("SetLoaderDialog", {
                type: 0,
                total: 1,
              });
            });
          }
        });
      } else {
        _this.$timeout(function () {
          _this.$rootScope.$emit("SetLoaderDialog", {
            type: 0,
            total: 1,
          });
        });
        _this.$timeout(function () {
          _this.remain_loading_count = 0;
        }, 300);
      }
      if (_this.$stateParams.jobType && _this.$stateParams.openings && _this.$stateParams.pay) {
        _this.event.hourly_rate = _this.$stateParams.pay;
        _this.event.openings = _this.$stateParams.openings;
        _this.openingsList.value = parseInt(_this.$stateParams.openings, 10);
        for (var i = 0; i < data.data.length; i++) {
          if (data.data[i].name === _this.$stateParams.jobType) {
            _this.event.jobble_type = data.data[i].id;
            break;
          }
        }
      }
      if (_this.$stateParams.t) {
        _this.map_state_params_to_fields();
      }
    } else {
      _this.remain_loading_count = 1;
      var loadingCount = 0;
      if (_this.$location.$$search.eid) {
        _this.$timeout(function () {
          _this.$rootScope.$emit("SetLoaderDialog", {
            type: 13,
            total: 2,
          });
        });
      } else {
        _this.$timeout(function () {
          _this.$rootScope.$emit("SetLoaderDialog", {
            type: 13,
            total: 1,
          });
        });
      }
      _this.$auth.getJobbleTypes().then(
        function (data) {
          _this.$rootScope.jobble_types = data.data;
          _this.jobble_types = data.data;
          if (_this.$location.$$search.eid) {
            var tempTimeArray = [];
            _this.isClone = true;
            _this.$events.getEventByIdTrimmed(_this.$location.$$search.eid, 1).then(function (eventResp) {
              _this.eventResponse = eventResp.data;
              if (_this.eventResponse.isSourcingPost) {
                _this.postType = "source";
                _this.event.isSourcingPost = true;
                _this.isSourcingPost = true;
              } else {
                _this.postType = "regular";
                _this.event.isSourcingPost = false;
                _this.isSourcingPost = false;
              }
              _this.event.isClone = true;
              try {
                eventResp.data.subEvents[0].deduppedJobbles[0].shifts.forEach(function (shift) {
                  var tempTimeObj = {};
                  tempTimeObj.contactInfo = {};
                  tempTimeObj.address =
                    shift.contactInfo.streetLine1 + " " + shift.contactInfo.city + " " + shift.contactInfo.state + " " + shift.contactInfo.zipCode;
                  tempTimeObj.start_time = moment(shift.timeInterval.startTime).tz(shift.contactInfo.place.timeZoneId).format("hh:mm A");
                  tempTimeObj.start_date = moment(shift.timeInterval.startTime).tz(shift.contactInfo.place.timeZoneId).format("MMM DD, YYYY");
                  tempTimeObj.contactInfo.streetLine1 = shift.contactInfo.streetLine1;
                  tempTimeObj.contactInfo.state = shift.contactInfo.state;
                  tempTimeObj.contactInfo.city = shift.contactInfo.city;
                  tempTimeObj.contactInfo.zipCode = shift.contactInfo.zipCode;
                  tempTimeObj.contactInfo.lat = shift.contactInfo.lat;
                  tempTimeObj.contactInfo.lng = shift.contactInfo.lng;
                  var diffmin = moment(shift.timeInterval.endTime).diff(shift.timeInterval.startTime, "minutes");
                  var diffhour = Math.floor(diffmin / 60);
                  tempTimeObj.hours = diffhour;
                  tempTimeObj.minutes = diffmin % 60;
                  tempTimeArray.push(tempTimeObj);
                });
              } finally {
                _this.event.timeIntervalsArray = tempTimeArray;
                _this.event.name = eventResp.data.name;
                _this.event.dress_code = eventResp.data.subEvents[0].deduppedJobbles[0].dressCode;
                _this.event.hourly_rate = (eventResp.data.subEvents[0].deduppedJobbles[0].payPerHour / 100).toString();
                _this.openingsList.value = eventResp.data.numberOfOpenings + eventResp.data.numberOfApprovedApplications;
                _this.event.openings = _this.openingsList.value;
                _this.calcNumbers();
                _this.event.jobble_details = eventResp.data.description;
                _this.event.event_type = eventResp.data.eventTypeId;
                _this.event.jobble_type = eventResp.data.subEvents[0].deduppedJobbles[0].jobbleType.id;
                _this.event.postIsPrivate = false;
                _this.step = 0;
                _this.event.cloudsForJobblePost = [];
                _this.remain_loading_count = 0;
                _this.determineIfPublished(eventResp);
                _this.determineIfPrivate(eventResp);
                _this.determineJobbleType();
                console.log("eventResp.data");
                console.dir(eventResp.data);
                console.dir(eventResp.data.subEvents[0].deduppedJobbles[0]);
                if (eventResp.data.subEvents[0].deduppedJobbles[0].manager) {
                  let manager_id = eventResp.data.subEvents[0].deduppedJobbles[0].manager.id;
                  _this.event.manager = manager_id;
                  _this.$timeout(function () {
                    _this.$rootScope.$emit("SetManagerFromBack", {
                      id: _this.event.manager,
                    });
                  });
                }
                _this.$timeout(function () {
                  _this.$rootScope.$emit("SetLoaderDialog", {
                    type: 0,
                    total: 1,
                  });
                });
              }
            });
          } else {
            _this.$timeout(function () {
              _this.remain_loading_count = 0;
              _this.$rootScope.$emit("SetLoaderDialog", {
                type: 0,
                total: 1,
              });
            });
          }
          if (_this.$stateParams.jobType && _this.$stateParams.openings && _this.$stateParams.pay) {
            _this.event.hourly_rate = _this.$stateParams.pay;
            _this.event.openings = _this.$stateParams.openings;
            _this.openingsList.value = parseInt(_this.$stateParams.openings, 10);
            for (var i = 0; i < data.data.length; i++) {
              if (data.data[i].name === _this.$stateParams.jobType) {
                _this.event.jobble_type = data.data[i].id;
                break;
              }
            }
          }
          _this.check_for_marketing_site_params();
        },
        function (data) {
          _this.jobble_types = [];
          _this.remain_loading_count--;
          if (data.status === 401) {
            _this.$state.go("signin");
          } else {
            _this.$timeout(function () {
              jQuery("#show-application-alert").trigger("click");
            }, 100);
          }
        }
      );
    }

    if (this.currentUser) {
      if (SecurityService.isUndefinedOrNull(this.currentUser.company.companyLogoUri)) {
        var _this = this;
        var photoLoop = function (value) {
          if (value < 0) {
            return;
          } else {
            _this.$timeout(function () {
              var reloadedUser = _this.$auth.reloadCurrentUser();
              if (reloadedUser) {
                if (reloadedUser.$$state.value.company.companyLogoUri) {
                  _this.currentUser = reloadedUser.$$state.value;
                  _this.currentUser.companyProfilePictureUrl = _this.currentUser.company.companyLogoUri;
                } else {
                  return photoLoop(value - 1);
                }
              } else {
                return photoLoop(value - 1);
              }
            }, 2000);
          }
        };
        photoLoop(3);
      }

      _this.checkForTeams();
    }

    _this.UpdateCurrentUserListener = _this.$rootScope.$on("UpdateCurrentUserPost", function ($event, params) {
      _this.updateCurrentUser(params);
    });

    _this.ShowPostModalCCListener = _this.$rootScope.$on("ShowPostModalCC", function ($event, params) {
      _this.showPostModalCC(params.user);
    });

    _this.ShowPostModalListener = _this.$rootScope.$on("ShowPostModal", function ($event, params) {
      _this.showPostModal(params.user);
    });

    _this.SetQuestionsToEventListener = _this.$rootScope.$on("SetQuestionsToEvent", function ($event, params) {
      _this.navigateTheWizard(params);
    });

    _this.setEventIdForDraftingListener = _this.$rootScope.$on("SetEventIdForDrafting", function (event, params) {
      _this.setEventIdForDrafting(params);
    });

    _this.SetProfilePictureListener = _this.$rootScope.$on("SetProfilePicture", function ($event, params) {
      _this.currentUser.company.companyLogoUri = params.picture;
    });

    _this.setJobbleTypesListenerScope = _this.$rootScope.$on("SetJobbleTypes", function (event, params) {
      console.log("_this.setJobbleTypesListenerScope");
      console.log("_this.setJobbleTypesListenerScope");
      console.log("_this.setJobbleTypesListenerScope");
      _this.setJobbleTypesListener(params);
    });

    _this.QuestionsTriggerListener = _this.$rootScope.$on("QuestionsTrigger", function ($event, params) {
      _this.questions = params.questions;
    });

    _this.SetOnSiteManagerListener = _this.$rootScope.$on("SetOnSiteManager", function ($event, params) {
      _this.event.manager = params.data;
    });

    _this.SetPostingTypeChangeListener = _this.$rootScope.$on("SetPostingTypeChange", function ($event, params) {
      _this.remain_loading_count = 1;
      _this.set_new_posting_type(params);
    });

    _this.PostEventFromModalListener = _this.$rootScope.$on("PostEventFromModal", function ($event, params) {
      if (!_this.isSourcingPost) {
        _this.postCreateEvent();
      } else {
        _this.handleSourcingPost();
      }
    });

    _this.CloseCreditCardModalListener = _this.$rootScope.$on("CloseCreditCardModal", function ($event, params) {
      _this.closeCreditCardModal(params);
    });

    if (this.$location.$$search.s) {
      _this.startRegPost("source");
    }

    if (_this.$location.$$search.tut) {
      _this.triggerPostTypeModal();
    }

    _this.$scope.$on("$destroy", _this.ShowPostModalListener);
    _this.$scope.$on("$destroy", _this.ShowPostModalCCListener);
    _this.$scope.$on("$destroy", _this.SetPostingTypeChangeListener);
    _this.$scope.$on("$destroy", _this.SetOnSiteManagerListener);
    _this.$scope.$on("$destroy", _this.CloseCreditCardModalListener);
    _this.$scope.$on("$destroy", _this.SetProfilePictureListener);
    _this.$scope.$on("$destroy", _this.setEventIdForDraftingListener);
    _this.$scope.$on("$destroy", _this.QuestionsTriggerListener);
    _this.$scope.$on("$destroy", _this.PostEventFromModalListener);
    _this.$scope.$on("$destroy", _this.SetQuestionsToEventListener);
    _this.$scope.$on("$destroy", _this.UpdateCurrentUserListener);
    _this.$scope.$on("$destroy", _this.setJobbleTypesListenerScope);

    if (_this.$location.$$search.edit) {
      var tempTimeArray = [];
      _this.step = 0;
      _this.isEdit = true;
      _this.remain_loading_count = 1;
      _this.$events.getEventById(parseInt(_this.$location.$$search.edit, 10)).then(function (eventResp) {
        _this.eventResponse = eventResp.data;
        _this.remain_loading_count = 0;
        if (_this.eventResponse.isSourcingPost) {
          _this.postType = "source";
        } else {
          _this.postType = "regular";
        }
        try {
          eventResp.data.subEvents[0].nonDuplicatedJobbles[0].shifts.forEach(function (shift) {
            var tempTimeObj = {};
            tempTimeObj.contactInfo = {};
            tempTimeObj.address =
              shift.contactInfo.streetLine1 + " " + shift.contactInfo.city + " " + shift.contactInfo.state + " " + shift.contactInfo.zipCode;
            tempTimeObj.start_time = moment(shift.timeInterval.startTime).tz(shift.contactInfo.timeZoneId).format("hh:mm A");
            tempTimeObj.start_date = moment(shift.timeInterval.startTime).tz(shift.contactInfo.timeZoneId).format("MMM DD, YYYY");
            tempTimeObj.contactInfo.streetLine1 = shift.contactInfo.streetLine1;
            tempTimeObj.contactInfo.state = shift.contactInfo.state;
            tempTimeObj.contactInfo.city = shift.contactInfo.city;
            tempTimeObj.contactInfo.zipCode = shift.contactInfo.zipCode;
            var diffmin = moment(shift.timeInterval.endTime).diff(shift.timeInterval.startTime, "minutes");
            var diffhour = Math.floor(diffmin / 60);
            tempTimeObj.hours = diffhour;
            tempTimeObj.minutes = diffmin % 60;
            tempTimeArray.push(tempTimeObj);
          });
        } finally {
          _this.event.timeIntervalsArray = tempTimeArray;
          _this.event.name = eventResp.data.name;
          _this.event.dress_code = eventResp.data.subEvents[0].nonDuplicatedJobbles[0].dressCode;
          _this.event.hourly_rate = (eventResp.data.subEvents[0].nonDuplicatedJobbles[0].payPerHour / 100).toString();
          _this.openingsList.value = eventResp.data.numberOfOpenings + eventResp.data.numberOfApprovedApplications;
          _this.event.openings = _this.openingsList.value;
          _this.event.jobble_details = eventResp.data.description;
          _this.event.event_type = eventResp.data.eventTypeId;
          _this.event.jobble_type = eventResp.data.subEvents[0].nonDuplicatedJobbles[0].jobbleTypeId;
          _this.event.postIsPrivate = false;
          _this.event.cloudsForJobblePost = [];
        }
      });
    }

    _this.getLatestCompanyPackage();
  }

  setLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").removeClass("wait");
    });
  }

  showDateAndTimeUI(isLoop) {
    // for date and time picker UI
    console.log("showDateAndTimeUI");
    console.dir(isLoop);
    console.dir(this.event);

    if (!isLoop) {
      setTimeout(function () {
        jQuery("#datepicker").datepicker({
          showOn: "both",
          buttonImage: "/app/vendor/images/calender.png",
          buttonImageOnly: true,
          buttonText: "Select date",
          dateFormat: "M dd, yy",
        });
        jQuery("#timepicker").timepicker({
          step: 15,
          timeFormat: "h:i A",
        });
        jQuery("#timepicker").on("showTimepicker", function () {
          jQuery(".ui-timepicker-wrapper").css("width", jQuery("#timepicker").width() + 10 + "px");
        });
      }, 100);
    } else {
      var dateLoop = function (value) {
        if (value < 0) {
          return;
        } else {
          setTimeout(function () {
            jQuery("#datepicker" + value).datepicker({
              showOn: "both",
              buttonImage: "/app/vendor/images/calender.png",
              buttonImageOnly: true,
              buttonText: "Select date",
              dateFormat: "M dd, yy",
            });
            jQuery("#timepicker" + value).timepicker({
              step: 15,
              timeFormat: "h:i A",
            });
            jQuery("#timepicker" + value).on("showTimepicker", function () {
              jQuery(".ui-timepicker-wrapper").css("width", jQuery("#timepicker" + value).width() + 10 + "px");
            });
          }, 100);
          dateLoop(value - 1);
        }
      };
      dateLoop(this.event.timeIntervalsArray.length);
    }
  }

  updateCurrentUser(params) {
    //console.log('in the controller');
    //console.dir(params);
    var _this = this;
    _this.$timeout(function () {
      _this.currentUser = params.user;
      _this.$localStorage.logged_user = params.user;
    }, 1000);
  }

  updateStartTimeModel() {
    var start_time = jQuery("#timepicker").val();
    if (start_time != undefined && start_time != null) {
      this.currentTimeInterval.start_time = start_time;
    }
  }

  validateEventForm(eventObj) {
    eventObj.openings = this.openingsList.value;

    var keys = Object.keys(eventObj);
    var values = keys.map(function (v) {
      return eventObj[v];
    });
    var retObj = {};

    retObj.status = true;
    retObj.message = "";

    for (var x = 0; x < keys.length; x++) {
      var val = eventObj[keys[x]];
      if (keys[x] == "event_type") {
        val = 1;
      }
      if (this.$security.isUndefinedOrNull(val) && keys[x] !== "jobble_type_name") {
        console.log("each key val");
        console.dir(val);
        console.dir(keys[x]);
        if (keys[x] === "manager") {
          retObj.status = false;
          retObj.message = "Please select a hiring manager before continuing.";
        }
        if (keys[x] === "name") {
          retObj.status = false;
          retObj.message = "Please provide a name for your job before continuing.";
        }
        if (keys[x] === "jobble_type") {
          retObj.status = false;
          retObj.message = "Please select a jobble type for your job before continuing.";
        }
        if (keys[x] === "dress_code") {
          if (this.postType === "source") {
          } else {
            retObj.status = false;
            retObj.message = "Please provide a dress code for your job before continuing.";
          }
        }
        if (keys[x] === "hourly_rate") {
          if (this.postType === "source") {
          } else {
            retObj.status = false;
            retObj.message = "Please provide an hourly rate for your job before continuing.";
          }
        }
        if (keys[x] === "openings") {
          retObj.status = false;
          retObj.message = "Please provide the number of openings for your job before continuing.";
        }
        if (keys[x] === "jobble_details") {
          retObj.status = false;
          retObj.message = "Please provide some job details for your job before continuing.";
        }
        return retObj;
      }
      if (keys[x] === "openings") {
        eventObj[keys[x]] = this.openingsList.value;
        if (eventObj[keys[x]] === "0") {
          retObj.status = false;
          retObj.message = "Please provide more than 0 openings";
          return retObj;
        }
      }
      if (keys[x] === "dress_code") {
        let dc = eventObj[keys[x]];
        if (dc.length >= 254) {
          retObj.status = false;
          retObj.message = "The Dress Code is too long. Please shorten the length and add what ever addition details in the Job Description.";
          return retObj;
        }
      }
      if (keys[x] === "hourly_rate") {
        if (this.postType === "source") {
          if (this.event.hourly_rate) {
            if (this.event.hourly_rate.indexOf("$") > -1) {
              retObj.status = false;
              retObj.message = "Please do not include the '$' sign when inputting an hourly rate.";
              return retObj;
            } else {
              var decimal_check = /^\d*\.?\d{0,2}$/.test(this.event.hourly_rate);
              if (!decimal_check) {
                retObj.status = false;
                retObj.message = "Please provide a pay rate of that has only two decimal places.";
                return retObj;
              }
            }
          } else {
            this.event.hourly_rate = 0;
          }
        } else {
          if (this.event.hourly_rate < this.hourly_rate_based_on_admin) {
            retObj.status = false;
            retObj.message = "Please provide a pay rate of at least $14.00 an hour.";
            return retObj;
          } else {
            if (this.event.hourly_rate.indexOf("$") > -1) {
              retObj.status = false;
              retObj.message = "Please do not include the '$' sign when inputting an hourly rate.";
              return retObj;
            } else {
              var decimal_check = /^\d*\.?\d{0,2}$/.test(this.event.hourly_rate);
              if (!decimal_check) {
                retObj.status = false;
                retObj.message = "Please provide a pay rate of that has only two decimals.";
                return retObj;
              }
            }
          }
        }
      }
      if (keys[x] === "timeToHire") {
        //console.log('WE HAVE TIME TO HIRE IN VALIDATING');
        //console.dir(this.event.timeToHire);
        if (this.event.timeToHire) {
          if (moment(this.event.timeToHire).isBefore(moment())) {
            retObj.status = false;
            retObj.message = "Please provide a hiring date that is a day in the future.";
            return retObj;
          }
        }
      }
      if (x + 1 === keys.length) {
        retObj.status = true;
        return retObj;
      }
    }
  }

  goToEventDetailOther() {
    this.step = 0;
    setTimeout(function () {
      jQuery("#datepicker").datepicker({
        showOn: "both",
        buttonImage: "/app/vendor/images/calender.png",
        buttonImageOnly: true,
        buttonText: "Select date",
        dateFormat: "M dd, yy",
      });
    }, 100);
  }

  gotoEventDetailStep() {
    var _this = this;
    setTimeout(function () {
      jQuery("#datepicker").datepicker({
        showOn: "both",
        buttonImage: "/app/vendor/images/calender.png",
        buttonImageOnly: true,
        buttonText: "Select date",
        dateFormat: "M dd, yy",
      });
    }, 100);
    if (_this.currentTimeInterval.address.adr_address) {
      if (
        _this.currentTimeInterval.address.adr_address === "" ||
        _this.currentTimeInterval.hours === "" ||
        _this.currentTimeInterval.minutes === "" ||
        _this.currentTimeInterval.start_date === "" ||
        _this.currentTimeInterval.start_time === ""
      ) {
        _this.currentTimeInterval.address.adr_address = "";
        _this.currentTimeInterval.hours = "";
        _this.currentTimeInterval.minutes = "";
        _this.currentTimeInterval.start_date = "";
        _this.currentTimeInterval.start_time = "";
      }
    } else {
      if (
        _this.currentTimeInterval.address === "" ||
        _this.currentTimeInterval.hours === "" ||
        _this.currentTimeInterval.minutes === "" ||
        _this.currentTimeInterval.start_date === "" ||
        _this.currentTimeInterval.start_time === ""
      ) {
        _this.currentTimeInterval.address = "";
        _this.currentTimeInterval.hours = "";
        _this.currentTimeInterval.minutes = "";
        _this.currentTimeInterval.start_date = "";
        _this.currentTimeInterval.start_time = "";
      }
    }
    _this.updateStartTimeModel();
    _this.step = 0;
    _this.displayErrorMessageThirdPage = false;
    _this.$timeout(function () {
      _this.$rootScope.$emit("SetManagerFromBack", {
        id: _this.event.manager,
      });
    });
  }

  gotoJobDetailStep(fromEdit) {
    this.updateStartTimeModel();
    if (this.event.timeIntervalsArray.length > 0 && !fromEdit) {
      this.step = 2;
    } else {
      this.step = 1;
    }
    this.showDateAndTimeUI();
  }

  goToRegi(type) {
    var _this = this;
    this.step = 3;
    this.postingLink = true;
    _this.$timeout(function () {
      _this.$rootScope.$emit("SetRegistrationLazy", {type: type});
    });
    _this.$timeout(function () {
      jQuery("#show-application-global-modal").trigger("click");
    }, 300);
  }

  removeShiftEdit(ti, index) {
    var _this = this;
    _this.event.timeIntervalsArray.splice(index, 1);
  }

  addShiftEdit(ti, index) {
    var _this = this;
    let ins = {
      address: null,
      contactInfo: {
        city: null,
        lat: null,
        lng: null,
        state: null,
        streetLine1: null,
        zipCode: null,
      },
      hours: 1,
      minnutes: 0,
      start_date: null,
      start_time: null,
    };
    let p1 = index + 1;
    _this.event.timeIntervalsArray.splice(p1, 0, ins);
    _this.showDateAndTimeUI(true);
  }

  editCurrentInterval() {
    this.gotoJobDetailStep(true);
    ////console.log(this.currentTimeInterval);
    ////console.log(this.event.timeIntervalsArray);
  }

  editInterval(timeInterval, index) {
    console.log("timeInterval");
    console.dir(timeInterval);

    timeInterval.temp_holder = timeInterval.address_temp;
    timeInterval.address_temp = timeInterval.address;

    this.currentTimeInterval = timeInterval;
    this.currentAction = "edit";

    var randomArray = [];
    randomArray = this.event.timeIntervalsArray;
    this.markAllShiftsAsNotBeingEdited();
    this.timeIntervalsArrayTemp = randomArray;
    this.showAllShifts = true;

    this.event.timeIntervalsArray.forEach(function (ti) {
      ti.isOverlapping = false;
    });

    this.currentTimeIntervalBackup = {
      address: this.currentTimeInterval.address.adr_address,
      start_date: this.currentTimeInterval.start_date,
      start_time: this.currentTimeInterval.start_time,
      hours: this.currentTimeInterval.hours,
      minutes: this.currentTimeInterval.minutes,
    };

    this.gotoJobDetailStep(true);
    this.shiftIsBeingEdited = true;
    this.setActiveClassToTimeIntervalTable(index);

    console.log("timeInterval after editing...");
    console.dir(timeInterval);
  }

  setActiveClassToTimeIntervalTable(index) {
    var _this = this;
    console.log("setActiveClassToTimeIntervalTable");
    console.dir(index);
    console.dir(_this.event.timeIntervalsArray);
    _this.event.timeIntervalsArray[index].isBeingEdited = true;
  }

  removeCurrentInterval() {
    let lenIntevals = this.event.timeIntervalsArray.length;
    if (lenIntevals > 1) {
      this.event.timeIntervalsArray.splice(lenIntevals - 1, 1);
      this.currentTimeInterval = this.event.timeIntervalsArray[this.event.timeIntervalsArray.length - 1];
    }
  }

  removeInterval(timeInterval, index) {
    var lenIntevals = this.event.timeIntervalsArray.length;

    if (lenIntevals > 1) {
      let shift_to_delete = this.event.timeIntervalsArray[index];
      this.event.timeIntervalsArray.splice(index, 1);
      this.currentTimeInterval = this.event.timeIntervalsArray[this.event.timeIntervalsArray.length - 1];
      if (!this.isClone) {
        this.setLoader();
        this.updateEventOnBackEnd(shift_to_delete, this.event.timeIntervalsArray);
      }
    }
  }

  updateEventOnBackEnd(shift_to_delete, shifts_left_over) {
    var _this = this;
    let shifts = [];
    try {
      shifts_left_over.forEach(function (shift) {
        let s = {};
        s.contactInfo = shift.contactInfo;
        s.timeInterval = {};
        s.timeInterval.startTime = shift.startDateAndTimeForDB;
        s.timeInterval.endTime = shift.endDateAndTimeForDB;
        shifts.push(s);
      });
    } catch (err) {
      alert("Error :" + err);
    } finally {
      _this.updateAfterRemove(shifts, shift_to_delete);
    }
  }

  updateAfterRemove(shifts, shift_to_delete) {
    var _this = this;
    let jid = null;
    try {
      if (_this.eventResponse) {
        jid = _this.eventResponse.subEvents[0].deduppedJobbles[0].id;
      } else {
        if (_this.eventForDraftingData) {
          if (_this.eventForDraftingData.draftData) {
            if (_this.eventForDraftingData.draftData.data) {
              jid = _this.eventForDraftingData.draftData.data.jobblePool.jobbles[0].id;
            }
          }
        }
      }
    } catch (err) {
      alert("Unable to find jobble id please contact support");
    }
    _this.$timeout(function () {
      _this.$rootScope.$emit("AutoSave", {
        event: _this.event,
        questions: _this.questions,
        update: true,
      });
    });

    console.log("shift_to_delete");
    console.dir(shift_to_delete);

    _this.$events.deleteShift(shift_to_delete).then(
      function (response) {
        console.log("response from edit shift");
        console.dir(response);
        _this.saving = false;
        _this.displayErrorMessageThirdPage = false;
        _this.unSetLoader();
      },
      function (error) {
        console.log("error");
        console.dir(error);
        _this.unSetLoader();
        alert("Error :" + error);
      }
    );

    /*
		_this.$events.updateExistingDraft(jid, shifts, _this.event).then(function(response){
			_this.saving = false;
			_this.displayErrorMessageThirdPage = false;
			_this.unSetLoader();
		}, function(error){
			_this.unSetLoader();
			alert("Error :" +error);
		});
		*/
  }

  addInterval() {
    console.log("addInterval");
    console.dir(this.event);
    console.dir(this.currentTimeInterval);
    console.dir(this.currentTimeInterval.address);
    if (this.sessionObj.isSaving) {
      this.displayErrorMessageThirdPage = true;
      this.message = "Please wait until job has been saved before proceeding.";
    } else {
      let newAddress = this.currentTimeInterval.address;

      var newInterval = {
        address: "",
        start_date: "",
        start_time: "",
        hours: "",
        minutes: "",
      };
      console.log("newInterval");
      console.dir(newInterval);
      this.showAllShifts = true;
      var randomArray = [];
      randomArray = this.event.timeIntervalsArray;
      this.timeIntervalsArrayTemp = randomArray;
      this.currentAction = "add";
      //this.event.timeIntervalsArray.push(newInterval);
      //this.currentTimeInterval = this.event.timeIntervalsArray[this.event.timeIntervalsArray.length - 1];
      this.currentTimeInterval = newInterval;
      this.editCurrentInterval();
    }
  }

  gotoJobReviewStep() {
    this.updateStartTimeModel();
    this.step = 3;
  }

  updateEventDuringCreation(jobblePool, event, status) {
    var _this = this;
    _this.$events.updateEventData(jobblePool, event).then(
      function (response) {
        _this.$timeout(function () {
          _this.$rootScope.$emit("AutoSaveTrigger", {pop: "off"});
        });
      },
      function (response) {
        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );
  }

  getLatestCompanyPackage() {
    var _this = this;
    if (_this.currentUser) {
      _this.$timeout(function () {
        _this.$auth.getCompanyPlan().then(
          function (response) {
            _this.currentUser.company.defaultPlan = response.data.company.defaultPlan;
            _this.currentUser.company.payByInvoice = response.data.company.payByInvoice;
            console.log("current user and plan");
            console.dir(_this.currentUser);
          },
          function (error) {
            console.log("error");
            console.dir(error);
          }
        );
      }, 1000);
    }
  }

  updateJobbleDuringCreation(jobblePool, event, status) {
    var _this = this;
    _this.$events.updateJobblePoolData(jobblePool, event).then(
      function (resp) {
        _this.$timeout(function () {
          _this.$rootScope.$emit("AutoSaveTrigger", {pop: "off"});
        });
      },
      function (resp) {
        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );
  }

  updateEventDetailsFromFirstPage(data, event, status) {
    var _this = this;
    var jobblePool = data.draftData.data.jobblePool;
    _this.$timeout(function () {
      _this.$rootScope.$emit("AutoSaveTrigger", {pop: "on"});
    });
    if (_this.arrayOfStatus.indexOf(2) > -1) {
      _this.updateJobbleDuringCreation(jobblePool, event, status);
    }
    if (_this.arrayOfStatus.indexOf(1) > -1) {
      _this.updateEventDuringCreation(jobblePool, event, status);
    }
    if (_this.arrayOfStatus.indexOf(3) > -1) {
      _this.addOrRemoveOpenings(data, event);
    }
  }

  addOrRemoveOpenings(data, event) {
    var _this = this;
    var y = 0;
    var x = 0;
    if (data.draftData.data.jobblePool.jobbles.length > event.openings) {
      y = data.draftData.data.jobblePool.jobbles.length - event.openings;
      _this.$events.removeOpeningsToEvent(data, event, y).then(function (response) {
        _this.$timeout(function () {
          _this.$rootScope.$emit("AutoSaveTrigger", {
            pop: "off",
          });
        });
      });
    } else {
      if (data.draftData.data.jobblePool.jobbles.length < event.openings) {
        y = event.openings - data.draftData.data.jobblePool.jobbles.length;
        //x = data.draftData.data.jobblePool.jobbles.length + y;
        _this.$events.addOpeningsToEvent(data, event, y).then(function (response) {
          _this.$timeout(function () {
            _this.$rootScope.$emit("AutoSaveTrigger", {
              pop: "off",
            });
          });
        });
      }
    }
  }

  submitEventDetail(arg) {
    var _this = this;
    console.log("submitEventDetail");
    console.dir(_this.event);
    console.log(JSON.stringify(_this.event));
    if (this.openings_for_clone) {
      var o = this.openings_for_clone.value;
      _this.event.openings = null;
      _this.event.openings = o;
    }
    if (_this.sessionObj.isSaving) {
      _this.displayFirstPageErrorMessage = true;
      _this.message = "Please wait until job has been saved before proceeding.";
    } else {
      var isFirstPageValid = _this.validateEventForm(_this.event);
      if (isFirstPageValid.status) {
        _this.displayFirstPageErrorMessage = false;
        _this.message = "";
        _this.step = 1;
        try {
          _this.timeIntervalsArrayTemp.forEach(function (interval, index) {
            if (
              interval.address === "" ||
              interval.hours === "" ||
              interval.minutes === "" ||
              interval.start_date === "" ||
              interval.start_time === ""
            ) {
              _this.timeIntervalsArrayTemp.splice(index, 1);
            }
          });
        } finally {
          if (_this.$location.$$search.eid || _this.$location.$$search.edit) {
            _this.showDateAndTimeUI(true);
            _this.statusBarStatus.step_2.visited = true;
            _this.populateTracker(2);
            _this.step = 5;
          } else {
            if (_this.event.timeIntervalsArray.length > 0 && !_this.$security.isUndefinedOrNull(_this.event.timeIntervalsArray[0].address)) {
              if (_this.postType === "regular" || _this.postType === "source") {
                if (
                  !_this.$security.isUndefinedOrNull(_this.event.timeIntervalsArray[0].address.adr_address) ||
                  _this.event.timeIntervalsArray[0].address.adr_address === ""
                ) {
                  _this.step = 1;
                  _this.populateTracker(1);
                  _this.event.timeIntervalsArray[0].address = null;
                  _this.statusBarStatus.step_2.visited = true;
                } else {
                  _this.step = 2;
                  _this.populateTracker(2);
                  _this.statusBarStatus.step_2.visited = true;
                  _this.updateEventWithLatestData();
                  _this.displayErrorMessageThirdPage = false;
                }
              } else {
                _this.step = 22;
                _this.populateTracker(22);
              }
            } else {
              _this.step = 1;
              _this.populateTracker(1);
              _this.statusBarStatus.step_2.visited = true;
            }
            _this.showDateAndTimeUI();
          }
        }
      } else {
        _this.displayFirstPageErrorMessage = true;
        _this.message = isFirstPageValid.message;
      }
    }
  }

  cancelShift() {
    if (
      (this.currentTimeInterval.address.adr_address === "" ||
        this.currentTimeInterval.hours === "" ||
        this.currentTimeInterval.minutes === "" ||
        this.currentTimeInterval.start_date === "" ||
        this.currentTimeInterval.start_time === "") &&
      this.currentAction !== "add"
    ) {
      this.currentTimeInterval.address = "";
      this.currentTimeInterval.hours = "";
      this.currentTimeInterval.minutes = "";
      this.currentTimeInterval.start_date = "";
      this.currentTimeInterval.start_time = "";
      this.step = 0;
    } else {
      if (this.currentAction == "add") {
        this.event.timeIntervalsArray.splice(this.event.timeIntervalsArray.length - 1, 1);
        this.currentTimeInterval = this.event.timeIntervalsArray[this.event.timeIntervalsArray.length - 1];
        this.step = 2;
      } else {
        this.currentTimeInterval.address = this.currentTimeIntervalBackup.address;
        this.currentTimeInterval.start_date = this.currentTimeIntervalBackup.start_date;
        this.currentTimeInterval.start_time = this.currentTimeIntervalBackup.start_time;
        this.currentTimeInterval.hours = this.currentTimeIntervalBackup.hours;
        this.currentTimeInterval.minutes = this.currentTimeIntervalBackup.minutes;
        this.step = 2;
      }
      this.currentAction = "";
    }
  }

  check_shifts(shifts) {
    var _this = this;
    console.log("check_shifts");
    console.log(shifts);
    let error_found = false;
    let result = {};
    let i1 = null;
    try {
      if (shifts) {
        shifts.forEach(function (shift, i) {
          if (!shift.hours) {
            result.error = true;
            i1 = i + 1;
            result.message = "The shift in position #" + i1 + " is missing the hours of the duration.";
            shift.has_error = true;
            result.shift = shift;
            error_found = true;
          }
          if (shift.minutes === null || angular.isUndefined(shift.minutes)) {
            //console.log("empty minutes...");
            //result.error=false;
            shift.minutes = 0;
            //result.set_mins_to_zero=true;
            /*
						result.error=true;
						i1=i+1;
						result.message="The shift in position #"+i1+" is missing the minutes of the duration.";
						shift.has_error=true;
						result.shift=shift;
						error_found=true;
						*/
          }
          if (!shift.start_date) {
            result.error = true;
            i1 = i + 1;
            result.message = "The shift in position #" + i1 + " is missing a start date.";
            shift.has_error = true;
            result.shift = shift;
            error_found = true;
          }
          if (!shift.start_time) {
            result.error = true;
            i1 = i + 1;
            result.message = "The shift in position #" + i1 + " is missing a start time.";
            shift.has_error = true;
            result.shift = shift;
            error_found = true;
          }
          if (!shift.address) {
            result.error = true;
            i1 = i + 1;
            result.message = "The shift in position #" + i1 + " is missing an address.";
            shift.has_error = true;
            result.shift = shift;
            error_found = true;
          }
        });
      } else {
      }
    } catch (err) {
      console.log("error");
      console.dir(err);
    }
    if (error_found === false) {
      result.error = false;
      _this.displayErrorMessageSecondPageNew = false;
    }
    return result;
  }

  submitDateAndLocationLoop(shifts) {
    var _this = this;

    _this.remain_loading_count = 1;

    this.shiftIsBeingEdited = false;

    _this.$timeout(function () {
      _this.$rootScope.$emit("SetLoaderDialog", {type: 11, total: 1});
    });

    let check_shifts = _this.check_shifts(shifts);

    if (check_shifts.error === false) {
      var shiftsLoop = function (value) {
        if (value > 0) {
          try {
            if (shifts[value - 1].address.adr_address) {
              try {
                shifts[value - 1].contactInfo = {};
                shifts[value - 1].contactInfo.lat = shifts[value - 1].address.lat;
                shifts[value - 1].contactInfo.lng = shifts[value - 1].address.lng;
                var addressSplit = shifts[value - 1].address.adr_address.split(",");
                addressSplit.forEach(function (part, index) {
                  if (part.indexOf("street-address") > -1) {
                    var streetArray = /<span[^>]*>(.*?)<\/span>/.exec(part);
                    shifts[value - 1].contactInfo.streetLine1 = streetArray[1];
                  }
                  if (part.indexOf("locality") > -1) {
                    var cityArray = /<span[^>]*>(.*?)<\/span>/.exec(part);
                    shifts[value - 1].contactInfo.city = cityArray[1];
                  }
                  if (part.indexOf("region") > -1) {
                    var regionAndZipArray = part.split("> <");

                    regionAndZipArray.forEach(function (p) {
                      if (p.indexOf("region") > -1) {
                        var stateArray = /\s<span[^>]*>(.*?)<\/span/.exec(p);
                        shifts[value - 1].contactInfo.state = stateArray[1];
                      }
                      if (p.indexOf("postal-code") > -1) {
                        var zipArray = /span[^>]*>(.*?)<\/span>/.exec(p);
                        shifts[value - 1].contactInfo.zipCode = zipArray[1];
                      }
                    });
                  }
                  if (index + 1 === addressSplit.length) {
                    shifts[value - 1].address =
                      shifts[value - 1].contactInfo.streetLine1 +
                      " " +
                      shifts[value - 1].contactInfo.city +
                      " " +
                      shifts[value - 1].contactInfo.state +
                      " " +
                      shifts[value - 1].contactInfo.zipCode;
                  }
                });
              } finally {
                _this.$security.getEventShiftTimezoneInfo(shifts[value - 1]).then(
                  function (response) {
                    if (response.data.length == 0) {
                      _this.remain_loading_count--;
                      _this.displayErrorMessageSecondPage = true;
                      _this.message = "Please return a more specific address.";
                      return;
                    }

                    var userTimeZoneName = moment.tz.guess();
                    var now = moment.tz(userTimeZoneName);
                    var nowThere = moment.tz(response.data[0].timeZoneId);
                    var timeInSec = (parseInt(now.utcOffset(), 10) - parseInt(nowThere.utcOffset())) * 60;
                    var zone = moment.tz.zone(moment.tz.guess());
                    var eventMangerOffsets = -zone.offsets[zone.offsets.length - 1];
                    var eventOffsets = response.data[0].rawOffset / 60000;
                    var tempEndDate = moment(shifts[value - 1].start_date + " " + shifts[value - 1].start_time)
                      .add(shifts[value - 1].hours, "hours")
                      .add(eventMangerOffsets - eventOffsets, "minutes");

                    shifts[value - 1].endDateAndTimeMomentObj = moment(tempEndDate).add(shifts[value - 1].minutes, "minutes");
                    shifts[value - 1].startDateAndTimeMomentObj = moment(shifts[value - 1].start_date + " " + shifts[value - 1].start_time).add(
                      eventMangerOffsets - eventOffsets,
                      "minutes"
                    );

                    shifts[value - 1].durationInMinutes = shifts[value - 1].endDateAndTimeMomentObj.diff(
                      shifts[value - 1].startDateAndTimeMomentObj,
                      "minutes"
                    );
                    shifts[value - 1].durationInHours = parseFloat((shifts[value - 1].durationInMinutes / 60).toFixed(2));
                    shifts[value - 1].startDateAndTimeForDB = shifts[value - 1].startDateAndTimeMomentObj.format();
                    shifts[value - 1].endDateAndTimeForDB = shifts[value - 1].endDateAndTimeMomentObj.format();

                    let dst_test = shifts[value - 1].startDateAndTimeForDB;
                    let dst_result = moment(dst_test).isDST();

                    console.log("dst_result");
                    console.dir(dst_result);

                    if (response.data[0].timeZoneId === "America/Phoenix" && dst_result === true) {
                      shifts[value - 1].startDateAndTimeForDB = moment(shifts[value - 1].startDateAndTimeForDB)
                        .add(1, "hours")
                        .format();
                      shifts[value - 1].endDateAndTimeForDB = moment(shifts[value - 1].endDateAndTimeForDB)
                        .add(1, "hours")
                        .format();
                    }

                    shifts[value - 1].cost = parseFloat(shifts[value - 1].durationInHours * (_this.event.hourly_rate * _this.event.openings));

                    if (shifts.length - value + 1 === shifts.length) {
                      _this.$timeout(function () {
                        _this.wereDoneWithLoop(shifts);
                      }, 1000);
                    }
                  },
                  function (response) {
                    _this.remain_loading_count--;
                    _this.$timeout(function () {
                      jQuery("#show-application-alert").trigger("click");
                    }, 100);
                  }
                );
              }
            } else {
              if (_this.postType === "regular") {
                console.log("regular post type...");

                _this.$security.getEventShiftTimezoneInfo(shifts[value - 1]).then(
                  function (response) {
                    if (response.data.length == 0) {
                      _this.remain_loading_count--;
                      _this.displayErrorMessageSecondPage = true;
                      _this.message = "Please return a more specific address.";
                      return;
                    }
                    var userTimeZoneName = moment.tz.guess();
                    var now = moment.tz(userTimeZoneName);
                    var nowThere = moment.tz(response.data[0].timeZoneId);
                    var timeInSec = (parseInt(now.utcOffset(), 10) - parseInt(nowThere.utcOffset())) * 60;
                    var zone = moment.tz.zone(moment.tz.guess());
                    var eventMangerOffsets = -zone.offsets[zone.offsets.length - 1];
                    var eventOffsets = response.data[0].rawOffset / 60000;
                    var tempEndDate = moment(shifts[value - 1].start_date + " " + shifts[value - 1].start_time)
                      .add(shifts[value - 1].hours, "hours")
                      .add(eventMangerOffsets - eventOffsets, "minutes");
                    shifts[value - 1].endDateAndTimeMomentObj = moment(tempEndDate).add(shifts[value - 1].minutes, "minutes");
                    shifts[value - 1].startDateAndTimeMomentObj = moment(shifts[value - 1].start_date + " " + shifts[value - 1].start_time).add(
                      eventMangerOffsets - eventOffsets,
                      "minutes"
                    );
                    shifts[value - 1].durationInMinutes = shifts[value - 1].endDateAndTimeMomentObj.diff(
                      shifts[value - 1].startDateAndTimeMomentObj,
                      "minutes"
                    );
                    shifts[value - 1].durationInHours = parseFloat((shifts[value - 1].durationInMinutes / 60).toFixed(2));

                    shifts[value - 1].startDateAndTimeForDB = shifts[value - 1].startDateAndTimeMomentObj.format();
                    shifts[value - 1].endDateAndTimeForDB = shifts[value - 1].endDateAndTimeMomentObj.format();

                    let dst_test = shifts[value - 1].startDateAndTimeForDB;
                    let dst_result = moment(dst_test).isDST();

                    console.log("dst_result");
                    console.dir(dst_result);

                    if (response.data[0].timeZoneId === "America/Phoenix" && dst_result === true) {
                      shifts[value - 1].startDateAndTimeForDB = moment(shifts[value - 1].startDateAndTimeForDB)
                        .add(1, "hours")
                        .format();
                      shifts[value - 1].endDateAndTimeForDB = moment(shifts[value - 1].endDateAndTimeForDB)
                        .add(1, "hours")
                        .format();
                    }

                    shifts[value - 1].cost = parseFloat(shifts[value - 1].durationInHours * (_this.event.hourly_rate * _this.event.openings));
                    if (shifts.length - value + 1 === shifts.length) {
                      _this.$timeout(function () {
                        _this.wereDoneWithLoop(shifts);
                        _this.remain_loading_count = 0;
                        _this.$timeout(function () {
                          _this.$rootScope.$emit("SetLoaderDialog", {
                            type: 0,
                            total: 1,
                          });
                        });
                      }, 1000);
                    }
                  },
                  function (response) {
                    _this.remain_loading_count--;
                    _this.$timeout(function () {
                      jQuery("#show-application-alert").trigger("click");
                    }, 100);
                  }
                );
              } else {
                shifts[value - 1].startDateAndTimeForDB = moment().format();
                shifts[value - 1].endDateAndTimeForDB = moment(shifts[value - 1].startDateAndTimeForDB)
                  .add(30, "days")
                  .format();
                shifts[value - 1].posting_duration = _this.currentTimeInterval.posting_duration;
                if (shifts.length - value + 1 === shifts.length) {
                  _this.wereDoneWithLoop(shifts);
                  _this.remain_loading_count = 0;
                  _this.$timeout(function () {
                    _this.$rootScope.$emit("SetLoaderDialog", {
                      type: 0,
                      total: 1,
                    });
                  });
                }
              }
            }
          } finally {
            return shiftsLoop(value - 1);
          }
        } else {
        }
      };
      shiftsLoop(shifts.length);
    } else {
      _this.set_errors(check_shifts);
    }
  }

  set_errors(error, idx) {
    var _this = this;
    _this.displayErrorMessageSecondPageNew = true;
    console.log("setting erros");
    console.dir(idx);
    _this.err_result = error;
    _this.remain_loading_count--;
  }

  wereDoneWithLoop(shifts) {
    var _this = this;

    try {
      for (var i = 0; i < shifts.length; i++) {
        if (_this.postType === "regular") {
          shifts[i].durationInMinutes = shifts[i].endDateAndTimeMomentObj.diff(shifts[i].startDateAndTimeMomentObj, "minutes");
          shifts[i].durationInHours = parseFloat((shifts[i].durationInMinutes / 60).toFixed(2));
          shifts[i].cost = parseFloat(shifts[i].durationInHours * (_this.event.hourly_rate * _this.event.openings));
          if (_this.$security.isUndefinedOrNull(shifts[i].hours)) {
            shifts[i].hours = "0";
          }
          if (_this.$security.isUndefinedOrNull(shifts[i].minutes)) {
            shifts[i].minutes = "0";
          }
        }
      }
    } finally {
      for (var i = 0; i < shifts.length; i++) {
        var isSecondPageValid = _this.validateDateAndLocationValue(shifts[i]);
        if (!isSecondPageValid.status) {
          _this.displayErrorMessageSecondPage = true;
          _this.remain_loading_count--;
          _this.message = isSecondPageValid.message;
          break;
        }
      }
    }
    try {
      if (isSecondPageValid.status) {
        var errorWithShifts = _this.compareShiftsToEachOther(_this.event.timeIntervalsArray);
        if (!errorWithShifts.status) {
          _this.displayErrorMessageThirdPage = false;
          if (_this.postType === "source") {
            console.log("i really hope we make it here");
            _this.step = 2;
          } else {
            _this.step = 2;
          }

          _this.remain_loading_count--;
        } else {
          _this.displayErrorMessageThirdPage = true;
          _this.message = errorWithShifts.message;
          _this.remain_loading_count--;
        }
      } else {
        _this.displayErrorMessageSecondPage = true;
        _this.message = isSecondPageValid.message;
      }
    } finally {
      //console.log('what is this going into the final page');
      //console.dir(_this.event);
    }
  }

  saveDraftListener() {
    var _this = this;

    if (_this.currentUser) {
      _this.$timeout(function () {
        _this.sessionObj.isSaving = true;
        _this.event.typeOfJobPosting = _this.postType;
        _this.$rootScope.$emit("AutoSave", {
          event: _this.event,
          questions: _this.questions,
        });
      });
    }
  }

  submitDateAndLocation() {
    this.setLoader();
    this.updateStartTimeModel();
    this.displayErrorMessageSecondPage = false;
    this.displayErrorMessageThirdPage = false;

    this.saving = true;

    var isSecondPageValid = this.validateSecondPage(this.currentTimeInterval);

    if (isSecondPageValid.status) {
      var _this = this;

      //_this.remain_loading_count++;

      if (_this.postType === "source") {
        console.log("getting the time zone info..");
        console.dir(_this.currentTimeInterval);

        _this.currentTimeInterval.contactInfo.lat = _this.currentTimeInterval.lat;
        _this.currentTimeInterval.contactInfo.lng = _this.currentTimeInterval.lng;

        this.$security.getEventShiftTimezoneInfo(_this.currentTimeInterval).then(
          function (response) {
            _this.remain_loading_count--;

            console.log("getEventShiftTimezoneInfo");
            console.dir(response);
            console.dir(response.data.length);

            if (response.data.length == 0) {
              _this.displayErrorMessageSecondPage = true;
              _this.message = "Please return a more specific address because the selected address has wrong zip code.";
              return;
            }

            _this.currentTimeInterval.startDateAndTimeMomentObj = moment();
            _this.currentTimeInterval.endDateAndTimeMomentObj = moment(_this.currentTimeInterval.startDateAndTimeMomentObj).add(30, "days");
            _this.currentTimeInterval.startDateAndTimeForDB = _this.currentTimeInterval.startDateAndTimeMomentObj.format();
            _this.currentTimeInterval.start_time = _this.currentTimeInterval.startDateAndTimeForDB;
            _this.currentTimeInterval.start_date = _this.currentTimeInterval.startDateAndTimeForDB;
            _this.currentTimeInterval.endDateAndTimeForDB = _this.currentTimeInterval.endDateAndTimeMomentObj.format();
            _this.currentTimeInterval.cost = 0;

            isSecondPageValid = _this.validateDateAndLocationValue(_this.currentTimeInterval);

            if (isSecondPageValid.status) {
              _this.step = 2;
              _this.currentTimeInterval.isError = undefined;
              if (_this.$security.isUndefinedOrNull(_this.currentTimeInterval.hours)) {
                _this.currentTimeInterval.hours = "0";
              }
              if (_this.$security.isUndefinedOrNull(_this.currentTimeInterval.minutes)) {
                _this.currentTimeInterval.minutes = "0";
              }
              _this.event.timeIntervalsArray.sort(function (a, b) {
                return new Date(a.startDateAndTimeForDB).getTime() - new Date(b.startDateAndTimeForDB).getTime();
              });
              console.log("_this.eventForDraftingData2222");
              console.dir(_this.eventForDraftingData);
              console.dir(_this.isEdit);

              if (_this.eventForDraftingData || _this.isEdit) {
                _this.event.jid = _this.$location.$$search.jid;
                _this.event.eid = _this.$location.$$search.edit;
                _this.addAdditionalShiftToAlreadyCreatedEvent(_this.eventForDraftingData, _this.event);
              } else {
                console.log("coming here...");
                _this.saveDraftListener();
                _this.unSetLoader();
                _this.saving = false;
              }
            } else {
              _this.currentTimeInterval.isError = "error-row";
              _this.displayErrorMessageSecondPage = true;
              _this.message = isSecondPageValid.message;
              _this.unSetLoader();
              _this.saving = false;
            }
          },
          function (response) {
            _this.remain_loading_count--;
            _this.$timeout(function () {
              jQuery("#show-application-alert").trigger("click");
            }, 100);
          }
        );
      } else {
        console.log("trak1");
        console.dir(_this.currentTimeInterval);
        console.dir(_this.event.timeIntervalsArray);
        _this.currentTimeInterval.contactInfo.lat = _this.currentTimeInterval.lat;
        _this.currentTimeInterval.contactInfo.lng = _this.currentTimeInterval.lng;

        this.$security.getEventShiftTimezoneInfo(_this.currentTimeInterval).then(
          function (response) {
            console.log("returned from places end point");
            console.dir(response);
            //_this.remain_loading_count--;
            if (response.data.length == 0) {
              _this.unSetLoader();
              _this.displayErrorMessageSecondPage = true;
              _this.message = "Please return a more specific address because the selected address has wrong zip code.";
              return;
            }

            var userTimeZoneName = moment.tz.guess();
            var now = moment.tz(userTimeZoneName);
            var nowThere = moment.tz(response.data[0].timeZoneId);
            var timeInSec = (parseInt(now.utcOffset(), 10) - parseInt(nowThere.utcOffset())) * 60;
            var zone = moment.tz.zone(moment.tz.guess());
            var eventMangerOffsets = -zone.offsets[zone.offsets.length - 1];
            var eventOffsets = response.data[0].rawOffset / 60000;
            var tempEndDate = moment(_this.currentTimeInterval.start_date + " " + _this.currentTimeInterval.start_time)
              .add(_this.currentTimeInterval.hours, "hours")
              .add(eventMangerOffsets - eventOffsets, "minutes");

            _this.currentTimeInterval.endDateAndTimeMomentObj = moment(tempEndDate).add(_this.currentTimeInterval.minutes, "minutes");
            _this.currentTimeInterval.startDateAndTimeMomentObj = moment(
              _this.currentTimeInterval.start_date + " " + _this.currentTimeInterval.start_time
            ).add(eventMangerOffsets - eventOffsets, "minutes");
            _this.currentTimeInterval.durationInMinutes = _this.currentTimeInterval.endDateAndTimeMomentObj.diff(
              _this.currentTimeInterval.startDateAndTimeMomentObj,
              "minutes"
            );
            _this.currentTimeInterval.durationInHours = parseFloat((_this.currentTimeInterval.durationInMinutes / 60).toFixed(2));
            _this.currentTimeInterval.startDateAndTimeForDB = _this.currentTimeInterval.startDateAndTimeMomentObj.format();
            _this.currentTimeInterval.endDateAndTimeForDB = _this.currentTimeInterval.endDateAndTimeMomentObj.format();
            _this.currentTimeInterval.cost = parseFloat(_this.currentTimeInterval.durationInHours * (_this.event.hourly_rate * _this.event.openings));

            let dst_test = _this.currentTimeInterval.startDateAndTimeForDB;
            let dst_result = moment(dst_test).isDST();

            if (response.data[0].timeZoneId === "America/Phoenix" && dst_result === true) {
              _this.currentTimeInterval.startDateAndTimeForDB = moment(_this.currentTimeInterval.startDateAndTimeForDB).add(1, "hours").format();
              _this.currentTimeInterval.endDateAndTimeForDB = moment(_this.currentTimeInterval.endDateAndTimeForDB).add(1, "hours").format();
            }

            isSecondPageValid = _this.validateDateAndLocationValue(_this.currentTimeInterval);

            console.log("isSecondPageValid");
            console.dir(isSecondPageValid);

            if (isSecondPageValid.status) {
              _this.step = 2;
              _this.saving = true;
              _this.currentTimeInterval.isError = undefined;
              if (_this.$security.isUndefinedOrNull(_this.currentTimeInterval.hours)) {
                _this.currentTimeInterval.hours = "0";
              }

              if (_this.$security.isUndefinedOrNull(_this.currentTimeInterval.minutes)) {
                _this.currentTimeInterval.minutes = "0";
              }

              console.log("right before sort");
              console.dir(_this.event.timeIntervalsArray);

              _this.event.timeIntervalsArray.sort(function (a, b) {
                return new Date(a.startDateAndTimeForDB).getTime() - new Date(b.startDateAndTimeForDB).getTime();
              });

              console.log("_this.currentTimeInterval1111");
              console.dir(_this.eventForDraftingData);
              console.dir(_this.isEdit);
              console.dir(_this.event);
              console.dir(_this.currentTimeInterval);
              console.dir(_this.event.timeIntervalsArray);

              if (_this.eventForDraftingData || _this.isEdit) {
                _this.event.jid = _this.$location.$$search.jid;
                _this.event.eid = _this.$location.$$search.edit;

                let lat_lng = {
                  lat: _this.currentTimeInterval.contactInfo.lat,
                  lng: _this.currentTimeInterval.contactInfo.lng,
                };

                _this.currentTimeInterval.contactInfo.lat = response.data[0].lat;
                _this.currentTimeInterval.contactInfo.lng = response.data[0].lng;

                console.log("before addAdditionalShiftToAlreadyCreatedEvent");
                console.dir(_this.event.timeIntervalsArray);
                //kkkkkkkkkkkkk

                console.log("zzzzzzzzzzz");
                console.dir(_this.shiftIsBeingEdited);
                _this.addAdditionalShiftToAlreadyCreatedEvent(_this.eventForDraftingData, _this.event);
              } else {
                console.log("we are down here..");
                console.dir(_this.event);
                console.dir(_this.isClone);

                if (_this.isClone) {
                  _this.currentTimeInterval.contactInfo.lat = response.data[0].lat;
                  _this.currentTimeInterval.contactInfo.lng = response.data[0].lng;
                  _this.addAdditionalShiftToAlreadyCreatedEvent(_this.eventForDraftingData, _this.event);
                } else {
                  _this.event.timeIntervalsArray[0].contactInfo.lat = response.data[0].lat;
                  _this.event.timeIntervalsArray[0].contactInfo.lng = response.data[0].lng;

                  _this.saveDraftListener();
                  _this.unSetLoader();
                  _this.saving = false;
                }
              }
            } else {
              _this.currentTimeInterval.isError = "error-row";
              _this.displayErrorMessageSecondPage = true;
              _this.message = isSecondPageValid.message;
              _this.unSetLoader();
              _this.saving = false;
            }
          },
          function (response) {
            _this.remain_loading_count--;
            _this.$timeout(function () {
              jQuery("#show-application-alert").trigger("click");
              _this.unSetLoader();
              _this.saving = false;
            }, 100);
          }
        );
      }
    } else {
      this.displayErrorMessageSecondPage = true;
      this.message = isSecondPageValid.message;
    }
  }

  addAdditionalShiftToAlreadyCreatedEvent(response, event) {
    var _this = this;

    var shifts = [];

    console.log("addAdditionalShiftToAlreadyCreatedEvent");
    console.dir(response);
    console.dir(event);
    console.dir(_this.timeIntervalsArrayTemp);
    console.log("_this.event.timeIntervalsArray -- lets look at these");
    console.dir(_this.event.timeIntervalsArray);
    console.dir(_this.currentTimeInterval);
    var tempShift = null;
    let shiftHolder = [];

    shiftHolder.push(_this.currentTimeInterval);

    console.log("zzzzzzzzzz3");
    console.dir(_this.shiftIsBeingEdited);

    if (_this.shiftIsBeingEdited) {
    } else {
      _this.event.timeIntervalsArray.push(_this.currentTimeInterval);
    }

    try {
      shiftHolder.forEach(function (shift) {
        console.log("_this.event.timeIntervalsArray each shift");
        console.dir(shift);
        tempShift = {
          contactInfo: {
            city: shift.contactInfo.city,
            state: shift.contactInfo.state,
            streetLine1: shift.contactInfo.streetLine1,
            zipCode: shift.contactInfo.zipCode,
            lat: shift.contactInfo.lat,
            lng: shift.contactInfo.lng,
          },
          timeInterval: {
            startTime: shift.startDateAndTimeForDB,
            endTime: shift.endDateAndTimeForDB,
          },
        };

        if (shift.id) {
          tempShift.id = shift.id;
        }
        //shifts.push(tempShift);
      });
    } finally {
      _this.$timeout(function () {
        _this.$rootScope.$emit("AutoSave", {
          event: _this.event,
          questions: _this.questions,
          update: true,
        });
      });

      console.log("how is it saving?");

      console.log("in the finally of shifts");
      console.dir(tempShift);
      console.dir(_this.isClone);

      if (!_this.isClone) {
        if (response) {
          let d = null;
          if (response.draftData) {
            d = response.draftData.data.jobblePool.jobbles[0].id;
          } else {
            d = response.data.subEvents[0].deduppedJobbles[0].id;
          }

          if (_this.shiftIsBeingEdited) {
            _this.$events.updateExistingShift(tempShift).then(
              function (response) {
                _this.findShiftPlaceId(response);
                _this.displayErrorMessageThirdPage = false;
                _this.$timeout(function () {
                  _this.unSetLoader();
                  _this.saving = false;
                  _this.shiftIsBeingEdited = false;
                }, 1500);
              },
              function (error) {
                console.log("in error");
                console.dir(error);
                _this.$timeout(function () {
                  _this.unSetLoader();
                  _this.shiftIsBeingEdited = false;
                }, 1500);
              }
            );
          } else {
            _this.$events.createNewShiftForExistingEvent(d, shifts, _this.event, tempShift).then(
              function (response) {
                _this.findShiftPlaceId(response);
                _this.displayErrorMessageThirdPage = false;
                _this.$timeout(function () {
                  _this.unSetLoader();
                  _this.saving = false;
                  _this.shiftIsBeingEdited = false;
                }, 1500);
              },
              function (error) {
                console.log("in error");
                console.dir(error);
                _this.$timeout(function () {
                  _this.unSetLoader();
                  _this.shiftIsBeingEdited = false;
                }, 1500);
              }
            );
          }
        } else {
          _this.$events.updateExistingDraft(null, shifts, _this.event).then(
            function (response) {
              console.log("response");
              console.dir(response);
              _this.displayErrorMessageThirdPage = false;
              _this.$timeout(function () {
                _this.unSetLoader();
                _this.saving = false;
                _this.shiftIsBeingEdited = false;
              }, 1500);
            },
            function (error) {
              console.log("in error");
              _this.$timeout(function () {
                _this.unSetLoader();
                _this.saving = false;
                _this.shiftIsBeingEdited = false;
              }, 1500);
              console.dir(error);
            }
          );
        }
      } else {
        console.log("lets update the  ui  the way we know");
        _this.$timeout(function () {
          _this.unSetLoader();
          _this.saving = false;
          _this.shiftIsBeingEdited = false;
        }, 1500);
      }
    }
  }

  setIdToFirstShift(response) {
    var _this = this;

    console.log("setIdToFirstShift");
    console.dir(response);
    console.dir(_this.event);
    _this.event.timeIntervalsArray[0].id = response.draftData.data.jobblePool.jobbles[0].shifts[0].id;
  }

  findShiftPlaceId(response) {
    var _this = this;

    console.log("findShiftPlaceId");
    console.dir(response);
    console.dir(_this.event.timeIntervalsArray);
    _this.event.timeIntervalsArray.forEach(function (shift) {
      if (!shift.id) {
        shift.id = response.data.shiftId;
      }
    });
  }

  validateSecondPage(eventObj) {
    var keys = Object.keys(eventObj);
    var values = keys.map(function (v) {
      return eventObj[v];
    });

    var retObj = {};
    retObj.status = true;

    for (var x = 0; x < keys.length; x++) {
      var val = eventObj[keys[x]];
      if (this.$security.isUndefinedOrNull(val)) {
        if (keys[x] === "address_temp") {
          retObj.status = false;
          retObj.message = "Please provide an address for a shift.";
          return retObj;
        }

        /*
	        if (keys[x] === 'posting_duration' && this.postType === 'source') {
	            retObj.status = false;
	            retObj.message = "Please provide a duration for how long you would like this job posting to be listed.";
	            return retObj;
	          }
				 */
        if (keys[x] === "start_date" && this.postType === "regular") {
          retObj.status = false;
          retObj.message = "Please provide a date and time for a shift.";
          return retObj;
        }
        if (keys[x] === "start_time" && this.postType === "regular") {
          retObj.status = false;
          retObj.message = "Please provide a date and time for a shift.";
          return retObj;
        }
      }
    }
    if (this.postType === "regular") {
      if (
        (eventObj.hours === "0" || this.$security.isUndefinedOrNull(eventObj.hours)) &&
        (eventObj.minutes === "0" || this.$security.isUndefinedOrNull(eventObj.minutes))
      ) {
        retObj.status = false;
        retObj.message = "Please provide a duration for a shift.";
        return retObj;
      }
    }

    eventObj.lat = eventObj.address.lat;
    eventObj.lng = eventObj.address.lng;

    console.log("check eventObj");
    console.dir(eventObj);

    if (!eventObj.address_temp) {
      eventObj.address_temp = {};
      eventObj.address_temp.adr_address = eventObj.address.adr_address;
    }

    if (eventObj.address_temp) {
      if (eventObj.address_temp.adr_address) {
        if (eventObj.address_temp.adr_address.indexOf("span") > -1) {
          eventObj.contactInfo = {};
          var addressSplit = eventObj.address_temp.adr_address.split(",");
          addressSplit.forEach(function (part, index) {
            if (part.indexOf("street-address") > -1) {
              var streetArray = /<span[^>]*>(.*?)<\/span>/.exec(part);
              eventObj.contactInfo.streetLine1 = streetArray[1];
            }
            if (part.indexOf("locality") > -1) {
              var cityArray = /<span[^>]*>(.*?)<\/span>/.exec(part);
              eventObj.contactInfo.city = cityArray[1];
            }
            if (part.indexOf("region") > -1) {
              var regionAndZipArray = part.split("> <");
              regionAndZipArray.forEach(function (p) {
                if (p.indexOf("region") > -1) {
                  var stateArray = /\s<span[^>]*>(.*?)<\/span/.exec(p);
                  eventObj.contactInfo.state = stateArray[1];
                }
                if (p.indexOf("postal-code") > -1) {
                  var zipArray = /span[^>]*>(.*?)<\/span>/.exec(p);
                  eventObj.contactInfo.zipCode = zipArray[1];
                }
              });
            }
            if (index + 1 === addressSplit.length) {
              eventObj.address =
                eventObj.contactInfo.streetLine1 +
                " " +
                eventObj.contactInfo.city +
                " " +
                eventObj.contactInfo.state +
                " " +
                eventObj.contactInfo.zipCode;
            }
          });
        }
      }
    }

    if (this.$security.isUndefinedOrNull(eventObj.contactInfo)) {
      retObj.status = false;
      retObj.message = "Please make sure to select an address from the drop down before proceeding. Please do not copy and paste.";
      return retObj;
    } else {
      if (
        this.$security.isUndefinedOrNull(eventObj.contactInfo.city) ||
        this.$security.isUndefinedOrNull(eventObj.contactInfo.streetLine1) ||
        this.$security.isUndefinedOrNull(eventObj.contactInfo.state) ||
        this.$security.isUndefinedOrNull(eventObj.contactInfo.zipCode)
      ) {
        retObj.status = false;
        retObj.message = "Please return a more specific address. For best results use a street address. (100 Main St. Boston, MA 02125).";
        return retObj;
      }
    }

    return retObj;
  }

  validateDateAndLocationValue(eventObj) {
    var r = {};
    r.status = true;
    if (this.postType === "source") {
      r.status = true;
    } else {
      if (eventObj.startDateAndTimeMomentObj.isBefore(moment())) {
        r.status = false;
        r.message = "The date and time you have selected has already passed.";
        return r;
      }
    }

    return r;
  }

  displayTotalCostOfJob() {
    var _this = this;
    _this.event.totalCostOfEvent = 0;
    try {
      _this.event.timeIntervalsArray.forEach(function (shift, i) {
        _this.event.totalCostOfEvent = _this.event.totalCostOfEvent + shift.cost;
      });
    } finally {
      return _this.event.totalCostOfEvent * (1 + _this.currentUser.company.defaultPlan.companyFeePct).toFixed(2);
    }
  }

  compareShiftsToEachOther(shifts) {
    //kkkkkkkkkk

    console.log("compare shifts to each other");
    console.dir(shifts);

    if (shifts) {
      try {
        shifts.forEach(function (shift, i) {
          shift.isOverlapping = false;
        });
      } catch (err) {
        console.log("ERROR SETTING OVERLAP BACK");
        console.log(err);
      }
    }

    var shiftsForCompare = shifts;

    var r = {};

    r.status = false;

    this.event.totalCostOfEvent = 0;
    this.event.totalMinutesWorked = 0;
    this.event.hoursForDisplay = 0;

    var _this = this;
    try {
      shifts.sort(function (a, b) {
        return new Date(a.startDateAndTimeForDB).getTime() - new Date(b.startDateAndTimeForDB).getTime();
      });
    } finally {
      try {
        shifts.forEach(function (shift, i) {
          var indexPlusOne = i + 1;
          if (i + 1 < shifts.length) {
            var shiftEndTime = shift.endDateAndTimeMomentObj;
            var startTimeOfNextShift = shiftsForCompare[indexPlusOne].startDateAndTimeMomentObj;
            if (startTimeOfNextShift.isBefore(shiftEndTime)) {
              shift.isOverlapping = true;
              shiftsForCompare[indexPlusOne].isOverlapping = true;
              r.status = true;
              r.message = "You have selected overlapping shifts. Please fix before proceeding.";
              return r;
            }
          }
          _this.event.totalCostOfEvent = _this.event.totalCostOfEvent + shift.cost;
          _this.event.totalMinutesWorked = _this.event.totalMinutesWorked + shift.durationInMinutes;
          _this.event.hoursForDisplay = _this.event.hoursForDisplay + shift.durationInHours;
          if (shifts.length === i + 1) {
            _this.event.totalMinutesWorked = Math.floor((_this.event.totalMinutesWorked / 60) * 100) / 100;
          }
        });
      } finally {
        return r;
      }
    }
  }

  loopThroughShiftsAndDoShit() {
    //console.log('loopThroughShiftsAndDoShit');
    //console.dir(this.event);
  }

  doesJobHaveClonedShift(shifts) {
    var _this = this;

    let result = false;

    console.log("does job have clone");
    console.dir(shifts);

    let clonedShift = shifts.find((o) => o.isClone === true);

    console.log("clonedShift");
    console.dir(clonedShift);

    if (clonedShift) {
      result = true;
    }

    console.log("result");
    console.dir(result);

    return result;
  }

  completeDateAndLocation() {
    var _this = this;

    console.log("whats the event now");
    console.dir(_this.event);

    let findClone = _this.doesJobHaveClonedShift(_this.event.timeIntervalsArray);

    console.log("findClone");
    console.dir(findClone);

    if (_this.event.openings_new) {
      _this.event.openings = _this.event.openings_new;
    }

    if (this.sessionObj.isSaving) {
      this.displayErrorMessageThirdPage = true;
      this.message = "Please wait until job has been saved before proceeding.";
    } else {
      _this.$timeout(function () {
        _this.$rootScope.$apply(function () {
          _this.$rootScope.$broadcast("setJobType", {
            postType: _this.postType,
            currentUser: _this.currentUser,
            sourcing: _this.isSourcingPost,
          });
        });
      });

      if (_this.isClone) {
        if (_this.eventResponse.surveyQuestions) {
          if (_this.eventResponse.surveyQuestions.length > 0) {
            _this.questions = _this.eventResponse.surveyQuestions;
          }
        }
      }

      if (_this.questions) {
        _this.$timeout(function () {
          _this.$rootScope.$apply(function () {
            _this.$rootScope.$broadcast("checkQuestions", {
              questions: _this.questions,
              clone: _this.isClone,
              postType: _this.postType,
              sourcing: _this.isSourcingPost,
            });
          });
        });
      }

      var errorWithShifts = _this.compareShiftsToEachOther(_this.event.timeIntervalsArray);

      if (!errorWithShifts.status) {
        _this.displayErrorMessageThirdPage = false;
        _this.statusBarStatus.step_3.visited = true;
        _this.populateTracker(6);
        _this.step = 6;
      } else {
        _this.displayErrorMessageThirdPage = true;
        _this.message = errorWithShifts.message;
      }
    }
  }

  closePostModalAndGoToEvents(goToOverviewPage) {
    var _this = this;

    _this.$timeout(function () {
      _this.remain_loading_count = 0;
      _this.unSetLoader();
      _this.saving = false;
      _this.$tracking.reportJobPost(_this.event, _this.jobble_types, _this.currentUser);
      jQuery("#modal-post-your-event .modal-header button.close").trigger("click");
      jQuery("#modal-post-event .modal-header button.close").trigger("click");
      jQuery(".modal-backdrop").remove();
    }, 1000);

    console.log("what do we have for information");
    console.dir(_this.eventForDraftingData);
    console.dir(_this.event);
    console.dir(goToOverviewPage);
    console.dir(_this.isClone);
    console.dir(_this.eventIdForOverview);

    _this.$timeout(function () {
      if (goToOverviewPage === true) {
        console.log("were true");

        let id = null;

        if (_this.eventIdForOverview) {
          id = _this.eventIdForOverview;
        } else {
          id = _this.eventForDraftingData.draftData.data.jobblePool.jobbles[0].event.id;
        }

        _this.$state.go("eventoverview", {eventId: id});
      } else {
        _this.$state.go("jobsdashboard", {clearQuery: true});
      }
    }, 1200);
  }

  collectCloudsFromBackEnd() {
    var _this = this;
    _this.remain_loading_count++;
    _this.$companies.getTeams().then(
      function (data) {
        _this.remain_loading_count--;
        for (var i = 0; i < data.data.length; i++) {
          var team = {
            name: data.data[i].name,
            id: data.data[i].id,
            numberOfUsers: data.data[i].numberOfUsers,
            checked: false,
          };
          _this.teams.push(team);
        }
      },
      function (data) {
        _this.remain_loading_count--;
        _this.teams = [];
        alert("There was a fatal error retrieving your teams. Please try again later");
      }
    );
  }

  collectClouds() {
    var _this = this;
    _this.event.cloudsForJobblePost = [];
    for (var i = 0; i < _this.teams.length; i++) {
      if (_this.teams[i].checked) {
        _this.event.cloudsForJobblePost.push(_this.teams[i].id);
      }
    }
  }

  postCreateEvent(num, goToJobOverview) {
    var _this = this;
    _this.displaySelectACloudError = false;
    _this.remain_loading_count++;
    _this.setLoader();

    if (!_this.$location.$$search.eid) {
      if (_this.event.postIsPrivate && _this.event.cloudsForJobblePost.length === 0) {
        _this.displaySelectACloudError = true;
        _this.unSetLoader();
        return;
      }
    }
    if (_this.event.cloudsForJobblePost.length > 0) {
      if (_this.isPref) {
        _this.event.postIsPrivate = false;
      } else {
        _this.event.postIsPrivate = true;
      }
    }
    if (this.sessionObj.isSaving) {
      alert("Please wait until your job has finished updating before trying to publish");
    } else {
      if (_this.isEdit) {
        var eid = _this.$location.$$search.edit;
        var jid = _this.$location.$$search.jid;
        _this.unSetLoader();
        _this.mapDataAndSave(eid, jid);
      } else {
        if (_this.eventForDraftingData) {
          console.log("ktrack1");
          let info = {};

          if (_this.event.cloudsForJobblePost.length > 0) {
            console.log("ktrack3");
            if (_this.eventForDraftingData.draftData) {
              console.log("ktrack4");
              _this.$events
                .pushTeamsOntoEvent(_this.eventForDraftingData.draftData.data.jobblePool, _this.event.cloudsForJobblePost, true)
                .then(function (r) {
                  _this.$events
                    .markJobAsPublished(_this.eventForDraftingData.draftData.data.jobblePool, _this.event, _this.questions)
                    .then(function (response) {
                      _this.$events
                        .markJobblesAsPublished(_this.eventForDraftingData.draftData.data.jobblePool, _this.event)
                        .then(function (bulkresp) {
                          console.log("_this.eventForDraftingData.draftData.data.jobblePool");
                          console.dir(_this.eventForDraftingData.draftData.data.jobblePool);
                          _this.closePostModalAndGoToEvents(goToJobOverview);
                          info.id = _this.eventForDraftingData.draftData.data.jobblePool.id;
                          info.visibility = "EXCLUSIVE";
                          _this.notifyUsers(info);
                        });
                    });
                });
            } else {
              console.log("ktrack5");
              _this.$events.markJobAsPublished(_this.eventForDraftingData, _this.event, _this.questions).then(function (response) {
                _this.$events.markJobblesAsPublished(_this.eventForDraftingData, _this.event).then(function (bulkresp) {
                  console.log("_this.eventForDraftingData 2");
                  console.dir(_this.eventForDraftingData);
                  _this.closePostModalAndGoToEvents(goToJobOverview);
                  info.id = _this.eventForDraftingData.data.subEvents[0].deduppedJobbles[0].jobblePoolId;
                  info.visibility = "EXCLUSIVE";
                  _this.notifyUsers(info);
                });
              });
            }
          } else {
            if (_this.eventForDraftingData.draftData) {
              console.log("ktrack6");
              _this.$events
                .markJobAsPublished(_this.eventForDraftingData.draftData.data.jobblePool, _this.event, _this.questions)
                .then(function (response) {
                  _this.$events.markJobblesAsPublished(_this.eventForDraftingData.draftData.data.jobblePool, _this.event).then(function (bulkresp) {
                    console.log("notify here");
                    console.dir(_this.eventForDraftingData.draftData.data.jobblePool);
                    info.id = _this.eventForDraftingData.draftData.data.jobblePool.id;
                    info.visibility = "PUBLIC";
                    _this.closePostModalAndGoToEvents(goToJobOverview);
                    _this.notifyUsers(info);
                  });
                });
            } else {
              console.log("ktrack7");
              _this.$events.markJobAsPublished(_this.eventForDraftingData, _this.event, _this.questions).then(function (response) {
                _this.$events.markJobblesAsPublished(_this.eventForDraftingData, _this.event).then(function (bulkresp) {
                  console.log("_this.eventForDraftingData");
                  console.dir(_this.eventForDraftingData);
                  _this.closePostModalAndGoToEvents(goToJobOverview);
                  info.id = _this.eventForDraftingData.data.subEvents[0].deduppedJobbles[0].jobblePoolId;
                  info.visibility = "PUBLIC";
                  _this.notifyUsers(info);
                });
              });
            }
          }
        } else {
          console.log("ktrack2");
          console.dir(_this.event);
          _this.$events.createEvent(_this.event).then(
            function (resp) {
              console.log("response from create event...");
              console.dir(resp.data);
              console.dir(_this.event.cloudsForJobblePost);

              let info = {};
              let event_id = resp.data.jobblePool.subEvent.event.id;

              _this.eventIdForOverview = resp.data.jobblePool.subEvent.event.id;
              let team_ids = _this.event.cloudsForJobblePost;
              console.log("team ids");
              console.dir(team_ids);
              if (team_ids.length > 0) {
                _this.$events.pushTeamsOntoEvent(event_id, team_ids, null, true).then(
                  function (response) {
                    console.log("pushTeamsOntoEvent resp");
                    console.dir(resp);
                    _this.closePostModalAndGoToEvents(goToJobOverview);
                    if (resp.data.notifyForNew === true) {
                      info.id = resp.data.jobblePool.id;
                      info.visibility = "EXCLUSIVE";
                      _this.notifyUsers(info);
                    }
                  },
                  function (error) {
                    console.log("in error");
                    console.dir(error);
                    _this.closePostModalAndGoToEvents(goToJobOverview);
                  }
                );
              } else {
                //kkkk
                //were going to at notify users end point here
                _this.closePostModalAndGoToEvents(goToJobOverview);
                if (resp.data.notifyForNew === true) {
                  info.id = resp.data.jobblePool.id;
                  info.visibility = "PUBLIC";
                  console.log("info");
                  console.dir(info);
                  _this.notifyUsers(info);
                }
              }
            },
            function (data) {
              _this.$timeout(function () {
                _this.unSetLoader();
                jQuery("#show-application-alert").trigger("click");
              }, 100);
            }
          );
        }
      }
    }
  }

  notifyUsers(info) {
    var _this = this;
    console.log("what is the info");
    console.dir(info);
    _this.$events.notifyJobblers(info).then(
      function (r) {
        console.log("notify response...");
        console.dir(r);
      },
      function (error) {
        console.log("in notify error");
        console.dir(error);
      }
    );
  }

  charge() {
    var _this = this;
    let data = {};
    if (_this.currentUser.company.defaultPlan.name) {
      if (_this.currentUser.company.defaultPlan.name.indexOf("No_Recruit_Charge") > -1) {
        _this.postCreateEvent();
        return;
      }
    }
    let invoice = _this.currentUser.company.payByInvoice;

    if (_this.currentUser.company.payByInvoice !== true) {
      data.token = _this.tokenToCharge;
    }
    data.amount = 5000;
    data.user = "accounting@jobble.com";
    data.note = "Payment for job posting.";
    _this.remain_loading_count++;
    _this.$companies.chargeForPost(data, invoice).then(
      function (response) {
        _this.$timeout(function () {
          _this.postCreateEvent();
        }, 500);
      },
      function (error) {
        alert("There was an error charging your card. Please contact support");
      }
    );
  }

  getJobbleTypeName() {
    var _this = this;
    var jobbleTypeName;
    for (var i = 0; i < this.jobble_types.length; i++) {
      if (this.jobble_types[i].id === parseInt(this.event.jobble_type)) {
        jobbleTypeName = this.jobble_types[i].name;
      }
    }
    return jobbleTypeName;
  }

  uploadLogo() {
    var _this = this;
    _this.$timeout(function () {
      jQuery("#upload-logo").trigger("click");
    });
  }

  uploadFiles(file, invalidFiles) {
    //console.log('uploadFiles');
    //console.dir(file);
    //console.dir(invalidFiles);
    //var uploadUrlCompany = _this.$env.getAPIEndPoint() + 'jbl/v1/companies/' + _this.currentUser.companyId + '/files?format=json&fileType=9&replace=true';
  }

  submitNewUserTest() {
    //console.log('auto submit...');
  }

  startRegPost(type) {
    this.step = 0;
    this.postType = type;
    setTimeout(function () {
      jQuery("#datepicker").datepicker({
        showOn: "both",
        buttonImage: "/app/vendor/images/calender.png",
        buttonImageOnly: true,
        buttonText: "Select date",
        dateFormat: "M dd, yy",
      });
    }, 100);
    this.reportJobTypeSelection(type);
  }

  reportJobTypeSelection(type) {
    var _this = this;
    if (_this.currentUser) {
      if (_this.currentUser.username.indexOf("jobble.com") === -1 || _this.currentUser.username.indexOf("jobbleapp.com") === -1) {
        if (type === "regular") {
          _this.$tracking.reportJobTypeSelectionOnDemand();
        } else {
          _this.$tracking.reportJobTypeSelectionSourcing();
        }
      }
    } else {
      if (type === "regular") {
        _this.$tracking.reportJobTypeSelectionOnDemand();
      } else {
        _this.$tracking.reportJobTypeSelectionSourcing();
      }
    }
  }

  backToPostType() {
    this.step = 10;
    this.displayFirstPageErrorMessage = false;
  }

  navigateTheWizard(params) {
    var _this = this;

    _this.event.questions = params.questions;
    _this.questions = params.questions;

    if (params.type === "forward") {
      if (_this.payWasChanged) {
        _this.recalculatePay();
      }

      _this.statusBarStatus.step_4.visited = true;
      _this.populateTracker(3);
      _this.step = 3;
    } else {
      if (_this.postType === "regular") {
        _this.step = 2;
      } else {
        _this.step = 2;
      }
    }
  }

  backToQuestions() {
    var _this = this;

    _this.step = 6;

    console.log("bbbbbbbbbb2");
    _this.$timeout(function () {
      _this.$rootScope.$apply(function () {
        _this.$rootScope.$broadcast("checkQuestions", {
          questions: _this.questions,
          clone: _this.isClone,
          postType: _this.postType,
        });
      });
    });
  }

  calcHourlyRate() {
    var _this = this;

    var str = "";

    if (_this.event.hourly_rate) {
      str = _this.event.hourly_rate;
      if (str.indexOf(".") > -1) {
        str = parseFloat(str).toFixed(2);
      } else {
        //console.log('no decimal');
        str = parseInt(str).toFixed(2);
      }
    } else {
      str = "N/A";
    }

    return str;
  }

  updateTracker(pageAttemptingToGoTo) {
    var _this = this;

    if (_this.step === 6) {
      _this.$timeout(function () {
        _this.$rootScope.$apply(function () {
          _this.$rootScope.$broadcast("triggerQuestionsGetter", {});
        });
      });
    }

    console.log("update tracker");
    console.dir(pageAttemptingToGoTo);

    if (pageAttemptingToGoTo !== 0) {
      _this.updateEventWithLatestData();
    }

    if (_this.tracker.arrayOfVistedSteps.indexOf(pageAttemptingToGoTo) > -1) {
      if (pageAttemptingToGoTo === 1) {
        if (_this.event.timeIntervalsArray.length > 0 && !_this.$security.isUndefinedOrNull(_this.event.timeIntervalsArray[0].address)) {
          if (_this.postType === "regular") {
            _this.updateEventWithLatestData();
            _this.tracker.previousStep = _this.step;
            _this.tracker.currentStep = 2;
            _this.step = 2;
            _this.showDateAndTimeUI();
          } else {
            _this.tracker.previousStep = _this.step;
            _this.tracker.currentStep = 22;
            _this.step = 22;
            _this.showDateAndTimeUI();
          }
        } else {
          _this.tracker.previousStep = _this.step;
          _this.tracker.currentStep = pageAttemptingToGoTo;
          _this.step = pageAttemptingToGoTo;
          _this.showDateAndTimeUI();
        }
      } else {
        if (pageAttemptingToGoTo === 6) {
          _this.$timeout(function () {
            _this.$rootScope.$apply(function () {
              _this.$rootScope.$broadcast("checkQuestions", {
                questions: _this.questions,
                clone: _this.isClone,
                postType: _this.postType,
              });
            });
          });
          _this.tracker.previousStep = _this.step;
          _this.tracker.currentStep = pageAttemptingToGoTo;
          _this.step = pageAttemptingToGoTo;
          _this.showDateAndTimeUI();
        } else {
          _this.tracker.previousStep = _this.step;
          _this.tracker.currentStep = pageAttemptingToGoTo;
          _this.step = pageAttemptingToGoTo;
          _this.showDateAndTimeUI();
          _this.$timeout(function () {
            _this.$rootScope.$emit("SetManagerFromBack", {
              id: _this.event.manager,
            });
          });
        }
      }
    } else {
      console.log("we dont have a match and so we cant go");
    }
  }

  updateEventWithLatestData() {
    if (this.eventForDraftingData && this.eventDetailsHaveChangedAfterCreation) {
      this.eventDetailsHaveChangedAfterCreation = false;
      this.updateEventDetailsFromFirstPage(this.eventForDraftingData, this.event, this.detailsChangedStatus);
    }
  }

  populateTracker(page) {
    var _this = this;

    if (_this.tracker.arrayOfVistedSteps.indexOf(page) > -1) {
      //console.log('we already have it so no needed to add it');
    } else {
      _this.tracker.arrayOfVistedSteps.push(page);
    }
  }

  checkForTeams() {
    var _this = this;

    if (!_this.$rootScope.teams) {
      _this.loadTeamsSimple();
    }
  }

  loadTeamsSimple() {
    var _this = this;

    var teamsSimple = [];

    _this.$companies.getTeamsSimple().then(
      function (data) {
        try {
          data.data.forEach(function (team, index) {
            var teamsObj = {};
            teamsObj.name = team.name;
            teamsObj.id = team.id;
            teamsSimple.push(teamsObj);
          });
        } finally {
          _this.$timeout(function () {
            _this.$rootScope.teamsSimple = teamsSimple;
          });
        }
      },
      function (data) {
        _this.$rootScope.teamsSimple = [];

        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );
  }

  setAvatarImageToUsersOfTeam(team) {
    var _this = this;

    team.users.forEach(function (userProfile) {
      if (!_this.$security.isUndefinedOrNull(userProfile.picture1s)) {
        userProfile.picture1s.forEach(function (pic) {
          if (pic.indexOf("75x75") > -1) {
            userProfile.pictureAvatarUrl = pic;
          }
          if (pic.indexOf("160x160") > -1) {
            userProfile.pictureAvatarUrlBig = pic;
          }
        });
      }

      if (_this.$security.isUndefinedOrNull(userProfile.pictureAvatarUrl)) {
        userProfile.pictureAvatarUrl = userProfile.pictureAvatarUrlBig;
      }
      if (_this.$security.isUndefinedOrNull(userProfile.pictureAvatarUrl)) {
        userProfile.pictureAvatarUrl = "/app/vendor/images/defaultimg.jpeg";
      }
    });
  }

  postEventLink() {
    var _this = this;

    console.log("postEventLink");
    console.dir(_this.event);
    console.dir(_this.currentUser);

    let freePlan = null;

    _this.postingLink = true;

    if (_this.currentUser) {
      freePlan = _this.currentUser.company.defaultPlan.name.indexOf("No_Recruit_Charge") > -1;
    }

    if (!_this.isSourcingPost || freePlan) {
      _this.$timeout(function () {
        jQuery("#modal-post-event-link").trigger("click");
      });
    } else {
      if (_this.currentUser) {
        if (_this.currentUser.company.payByInvoice === true) {
          //alert("Hello");

          _this.$timeout(function () {
            jQuery("#modal-post-event-link").trigger("click");
          });
        } else {
          if (_this.currentUser.company.undeletedPaymentInfos.length > 0) {
            _this.$timeout(function () {
              _this.$rootScope.$emit("SetPayForPostData", {
                cards: true,
              });
              jQuery("#link-modal-pick-card").trigger("click");
            });
          } else {
            _this.$timeout(function () {
              _this.$rootScope.$emit("SetPayForPostData", {});
              jQuery("#link-modal-add-card").trigger("click");
            });
          }
        }
      }
    }
  }

  showPostModalCC(user) {
    var _this = this;

    console.log("showPostModal");
    console.dir(user);

    if (user) {
      _this.tokenToCharge = user.company.paymentInfos[0].cardToken;
    }
    _this.$timeout(function () {
      jQuery("#modal-post-event-link").trigger("click");
    }, 500);
  }

  showPostModalCC(user) {
    var _this = this;

    console.log("showPostModal");
    console.dir(user);

    if (user) {
      _this.tokenToCharge = user.company.paymentInfos[0].cardToken;
    }
    _this.$timeout(function () {
      jQuery("#modal-post-event-link").trigger("click");
    }, 500);
  }

  jobblerRateOnBoard(rate) {
    var _this = this;

    if (rate) {
      rate = parseFloat(rate);
      rate = rate * (1 - _this.currentUser.company.defaultPlan.jobblerFeePct);
      return rate;
    }
  }

  calcNumbers() {
    var _this = this;
    _this.detailsChanged(2, true);
    if (isNaN(_this.event.hourly_rate_adj)) {
      _this.event.hourly_rate_adj = "";
      if (_this.isClone || _this.ismarketing) {
        _this.event.hourly_rate_adj = (parseFloat(_this.event.hourly_rate) * (1 - _this.currentUser.company.defaultPlan.jobblerFeePct)).toFixed(2);
      }
    } else {
      if (!_this.currentUser) {
        _this.event.hourly_rate_adj = (parseFloat(_this.event.hourly_rate) * 0.75).toFixed(2);
      } else {
        _this.event.hourly_rate_adj = (parseFloat(_this.event.hourly_rate) * (1 - _this.currentUser.company.defaultPlan.jobblerFeePct)).toFixed(2);
      }
      if (isNaN(_this.event.hourly_rate_adj)) {
        _this.event.hourly_rate_adj = "";
      }
    }
  }

  calcNumbersAdj() {
    var _this = this;
    _this.detailsChanged(2, true);
    if (isNaN(_this.event.hourly_rate)) {
      _this.event.hourly_rate = "";
    } else {
      if (!_this.currentUser) {
        let p = 100 - 0.25 * 100;
        let x = parseFloat(_this.event.hourly_rate_adj) * 100;
        let z = x / p;
        _this.event.hourly_rate = z.toFixed(2);
      } else {
        let p = 100 - _this.currentUser.company.defaultPlan.jobblerFeePct * 100;
        let x = parseFloat(_this.event.hourly_rate_adj) * 100;
        let z = x / p;
        _this.event.hourly_rate = z.toFixed(2);
      }
      if (isNaN(_this.event.hourly_rate)) {
        _this.event.hourly_rate = "";
      }
    }
  }

  setEventIdForDrafting(data) {
    var _this = this;
    console.log("SetEventIdForDrafting");
    console.dir(data);
    _this.eventForDraftingData = data;
    _this.saving = false;
    _this.sessionObj.isSaving = false;
    _this.displayErrorMessageThirdPage = false;
    _this.remain_loading_count = 0;
    _this.setIdToFirstShift(data);
  }

  populateDetails(status) {
    var _this = this;
    if (_this.arrayOfStatus.indexOf(status) > -1) {
    } else {
      _this.arrayOfStatus.push(status);
    }
  }

  detailsChanged(status, payWasChanged) {
    var _this = this;
    if (_this.eventForDraftingData) {
      _this.populateDetails(status);
      _this.eventDetailsHaveChangedAfterCreation = true;
      if (payWasChanged) {
        _this.payWasChanged = true;
      }
    }
  }

  changeOpeningsOnClone() {
    var _this = this;

    let openings_int = parseInt(_this.openings_for_clone.value, 10);
    _this.event.openings_new = openings_int;
    console.dir(_this.event);
  }

  recalculatePay() {
    var _this = this;
    _this.event.totalCostOfEvent = parseFloat(_this.event.hourly_rate) * _this.event.hoursForDisplay * _this.event.openings;
  }

  setJobbleTypesListener(params) {
    var _this = this;
    console.log("setJobbleTypesListener");
    console.dir(params);

    _this.jobble_types = params.jobbleTypes;
  }

  displayTotalCostOfJob() {
    var _this = this;
    _this.event.totalCostOfEvent = 0;
    try {
      _this.event.timeIntervalsArray.forEach(function (shift, i) {
        _this.event.totalCostOfEvent = _this.event.totalCostOfEvent + shift.cost;
      });
    } finally {
      return _this.event.totalCostOfEvent * (1 + _this.currentUser.company.defaultPlan.companyFeePct).toFixed(2);
    }
  }

  setPostType(arg) {
    var _this = this;

    console.log("postOptions.value");
    console.dir(_this.postOptions.value);
    console.dir(arg);
    console.dir(_this.event);
    console.dir(_this.eventForDraftingData);

    if (arg === "Sourcing") {
      _this.isSourcingPost = true;
      _this.postType = "source";
      _this.postOptions.value = "Sourcing";
      if (_this.currentUser) {
        _this.storePreferredPostType(1);
        if (_this.isClone) {
          _this.tempEventHolderForSwitchingDuringClones.push(_this.event);
          _this.mapEvent(1);
          console.log("console.dir(_this.tempEventHolderForSwitchingDuringClones)");
          console.dir(_this.tempEventHolderForSwitchingDuringClones);
        } else {
          console.log("not a clone....");
          if (_this.eventForDraftingData) {
            _this.updatePostTypeOnBackEnd(arg);
          }
        }
      }
    } else {
      _this.isSourcingPost = false;
      _this.postType = "regular";
      _this.postOptions.value = "Ondemand";
      if (_this.currentUser) {
        _this.storePreferredPostType(2);
        if (_this.isClone) {
          _this.tempEventHolderForSwitchingDuringClones.push(_this.event);
          _this.mapEvent(2);
          console.log("tempEventHolderForSwitchingDuringClones");
          console.dir(_this.tempEventHolderForSwitchingDuringClones);
        }
      }
    }
  }

  updatePostTypeOnBackEnd(arg) {
    var _this = this;
    let is_connect = null;
    if (arg === "Sourcing") {
      is_connect = true;
    } else {
      is_connect = false;
    }
    let event_id = _this.eventForDraftingData.draftData.data.jobblePool.jobbles[0].eventId;
    if (event_id) {
      let payload = {};
      payload.event_id = event_id;
      payload.isSourcingPost = is_connect;
      _this.$events.updatePostType(payload).then(
        function (response) {
          console.log("response");
          console.dir(response);
        },
        function (error) {
          console.log("error");
          console.dir(error);
        }
      );
    }
  }

  mapEvent(type) {
    var _this = this;

    if (type === 1) {
      console.log("type 1");
      console.dir(_this.event);
    } else {
      console.log("type 2");
      console.dir(_this.event);
    }
  }

  triggerPostTypeModal() {
    var _this = this;

    _this.$timeout(function () {
      jQuery("#choose-post-type").modal();
    }, 500);

    _this.$timeout(function () {
      _this.$location.search("tut", null);
      _this.$location.replace();
    }, 1000);
  }

  selectPostType(x) {
    var _this = this;

    //do the loader here
    console.log("selectPostType");
    _this.$timeout(function () {
      jQuery("#choose-post-type").modal("toggle");
    }, 300);

    if (x === 1) {
      _this.postOptions.value = "Sourcing";
      _this.isSourcingPost = true;
      _this.postType = "source";
    } else if (x === 2) {
      _this.postOptions.value = "On-demand";
      _this.postType = "regular";
      _this.isSourcingPost = false;
    } else if (x === 3) {
      _this.postOptions.value = "On-demand";
      _this.postType = "regular";
      _this.isSourcingPost = false;
    }
    if (x === 3) {
      if (_this.currentUser) {
        _this.$companies.update_post_type(0).then(
          function (response) {
            _this.$localStorage.logged_user.company.postingTypesAllowed = response.data.postingTypesAllowed;
            _this.currentUser.company.postingTypesAllowed = response.data.postingTypesAllowed;
            _this.set_new_post_types_to_header(response.data.postingTypesAllowed);
            _this.$timeout(function () {
              _this.$state.go("postorder");
            }, 500);
          },
          function (error) {
            console.log("error");
            console.dir(error);
          }
        );
      }
    } else {
      if (_this.currentUser) {
        _this.storePreferredPostType(x);
      }
    }
  }

  set_new_post_types_to_header(types) {
    var _this = this;
    _this.$timeout(function () {
      _this.$rootScope.$emit("SetNewPostTypesToHeader", types);
    });
  }

  storePreferredPostType(type) {
    var _this = this;
    if (type === 3) {
      console.log("store this on the backend");
      console.dir(type);
    } else {
      _this.$companies.storePreferredPostType(type).then(
        function (response) {
          _this.$auth.reloadNewPostingType().then(
            function (success) {
              _this.currentUser.company.payPerConnect = success.data.company.payPerConnect;
            },
            function (error) {}
          );
        },
        function (error) {
          alert("Error storing preferred posting types");
        }
      );
    }
  }

  setPostTypeInit() {
    var _this = this;
    if (_this.currentUser) {
      if (_this.$stateParams.pt) {
        if (_this.$stateParams.pt === "ondemand") {
          _this.postOptions.value = "On-demand";
          _this.isSourcingPost = false;
          _this.postType = "regular";
        } else {
          _this.postOptions.value = "Sourcing";
          _this.isSourcingPost = true;
          _this.postType = "source";
        }
        return;
      }
      if (_this.currentUser.company.payPerConnect === 1) {
        _this.postOptions.value = "Sourcing";
        _this.isSourcingPost = true;
        _this.postType = "source";
      } else {
        _this.postOptions.value = "On-demand";
        _this.isSourcingPost = false;
        _this.postType = "regular";
      }
    }
  }

  closeCreditCardModal(data) {
    var _this = this;
    _this.tokenToCharge = data.card.cardToken;
    _this.$timeout(function () {
      jQuery("#modal-pick-card .modal-header button.close").trigger("click");
    });

    _this.$timeout(function () {
      jQuery("#modal-post-event-link").trigger("click");
    }, 500);
  }

  handleSourcingPost() {
    var _this = this;
    _this.$timeout(function () {
      _this.$rootScope.$emit("SetPayForPostData", {});
      jQuery("#link-modal-add-card").trigger("click");
    }, 600);
  }

  locationKeyPress(event) {
    console.log("locationKeyPress");
    console.dir(event);
    console.dir(timeInterval.address);
  }

  submitLocation() {
    var _this = this;
  }

  setPaymentPlan() {
    var _this = this;
  }

  checkForAdmin() {
    var _this = this;
    if (_this.currentUser) {
      if (_this.currentUser.username.indexOf("jobble.com") > -1 || _this.currentUser.username.indexOf("jobbleapp.com") > -1) {
        _this.hourly_rate_based_on_admin = 1;
      } else {
        _this.hourly_rate_based_on_admin = 14;
      }
    }
  }

  determineIfPrivate(event) {
    var _this = this;
    if (event.data.orderNumber) {
      _this.event.orderNumber = event.data.orderNumber;
    }
  }

  determineIfPublished(event) {
    var _this = this;
    if (!event.data.subEvents[0].deduppedJobbles[0].isPublished) {
      _this.eventForDraftingData = event;
    }
  }

  check_for_state_params() {
    var _this = this;
    console.log("_this.$stateParams");
    console.dir(_this.$stateParams);

    if (_this.$stateParams.job_posting_type === "sourcing") {
      _this.postType = "source";
      _this.isSourcingPost = true;
    } else if (_this.$stateParams.job_posting_type === "ondemand") {
      _this.postType = "regular";
      _this.isSourcingPost = false;
    } else {
      console.log("deal with delivery tonight");
    }
  }

  set_new_posting_type(params) {
    var _this = this;
    if (params.posting_type_set === "ondemand") {
      _this.postType = "regular";
      _this.isSourcingPost = false;
    } else {
      _this.postType = "source";
      _this.isSourcingPost = true;
    }
    _this.$timeout(function () {
      _this.remain_loading_count = 0;
    }, 300);
  }

  map_state_params_to_fields() {
    var _this = this;
    let data = {};
    _this.ismarketing = true;
    if (_this.$stateParams.job_posting_type === "ondemand") {
      data.dress_code = _this.$stateParams.dress_code;
      data.job_description = _this.$stateParams.job_description;
      data.job_posting_type = _this.$stateParams.job_posting_type;
      data.job_title = _this.$stateParams.job_title;
      data.jobble_type = _this.$stateParams.jobble_type;
      data.pay_rate = _this.$stateParams.pay_rate;
      data.pay_rate_jblr = _this.$stateParams.pay_rate_jblr;
    } else if (_this.$stateParams.job_posting_type === "sourcing") {
      data.job_description = _this.$stateParams.job_description;
      data.job_posting_type = _this.$stateParams.job_posting_type;
      data.job_title = _this.$stateParams.job_title;
      data.jobble_type = _this.$stateParams.jobble_type;
      data.pay_rate = _this.$stateParams.hourly_rate;
    }
    data.token = _this.$stateParams.t;
    let promise = _this.$auth.validate_from_marketing_site(data.token);
    promise.then(
      function (response) {
        _this.handle_marketing_user_response(response.data, data);
        _this.currentUser = response.data;
      },
      function (error) {
        _this.handle_marketing_user_error(error);
      }
    );
  }

  handle_marketing_user_response(response, data) {
    var _this = this;
    if (data.job_posting_type === "ondemand") {
      _this.map_marketing_event(data, 1);
    } else if (data.job_posting_type === "sourcing") {
      _this.map_marketing_event(data, 2);
    } else if (data.job_posting_type === "delivery") {
      _this.map_marketing_event(data, 3);
    }
  }

  check_for_marketing_site_params() {
    var _this = this;
    let data = {};
    console.log("***check_for_marketing_site_params**");
    console.dir(_this.$location.$$search);
    console.dir(_this.$stateParams);
    if (_this.$stateParams) {
      if (_this.$stateParams.job_posting_type) {
        _this.map_state_params_to_fields();
        return;
      }
    }
    if (_this.currentUser) {
      _this.$location.$$search.t = _this.currentUser.access_token;
    }
    if (_this.$location.$$search.t && _this.$location.$$search.job_posting_type) {
      _this.ismarketing = true;
      data.dress_code = _this.$location.$$search.dress_code;
      data.job_description = _this.$location.$$search.job_description;
      data.job_posting_type = _this.$location.$$search.job_posting_type;
      data.job_title = _this.$location.$$search.job_title;
      data.jobble_type = _this.$location.$$search.jobble_type;
      data.pay_rate = _this.$location.$$search.pay_rate;
      data.pay_rate_jblr = _this.$location.$$search.pay_rate_jblr;
      data.token = _this.$location.$$search.t;
      let promise = _this.$auth.validate_from_marketing_site(data.token);
      promise.then(
        function (response) {
          _this.handle_marketing_user_response(response.data, data);
          _this.currentUser = response.data;
        },
        function (error) {
          _this.handle_marketing_user_error(error);
        }
      );
    } else if (!_this.$location.$$search.t && !_this.currentUser) {
      data = _this.$location.$$search;
      data.preserve = true;
      _this.$state.go("signin", data);
    }
  }

  map_marketing_event(data, type) {
    var _this = this;
    let event = {};
    if (type === 1) {
      let jt_obj = this.find_jobble_type(data.jobble_type);
      _this.$timeout(function () {
        _this.event.hourly_rate = data.pay_rate;
        _this.event.name = data.job_title;
        _this.event.jobble_type_name = jt_obj.name;
        _this.event.dress_code = data.dress_code;
        _this.event.jobble_details = data.job_description;
        _this.calcNumbers();
      }, 100);
    } else if (type === 2) {
      let jt_obj = this.find_jobble_type(data.jobble_type);
      _this.$timeout(function () {
        _this.event.hourly_rate = data.pay_rate;
        _this.event.name = data.job_title;
        _this.event.jobble_type_name = jt_obj.name;
        //_this.event.dress_code=data.dress_code;
        _this.event.jobble_details = data.job_description;
        _this.calcNumbers();
      }, 100);
    } else if (type === 3) {
      console.log("map delivery");
    }
    _this.$timeout(function () {
      _this.$rootScope.$emit("UpdateCurrentUser", {
        user: _this.currentUser,
      });
    }, 300);
  }

  handle_marketing_user_error(error) {
    var _this = this;
    console.log("handle_marketing_user_error");
    console.dir(error);
  }

  find_jobble_type(jt_name) {
    var _this = this;
    let jt_find = _this.jobble_types.find((o) => o.name === jt_name);
    let ret = {};
    ret.id = jt_find.id;
    ret.name = jt_find.name;
    _this.event.jobble_type = jt_find.id;
    return ret;
  }

  determineJobbleType() {
    var _this = this;
    let jt_find = _this.jobble_types.find((o) => o.id === _this.event.jobble_type);
    _this.set_openings();
    _this.$timeout(function () {
      _this.event.jobble_type = jt_find.id;
      _this.event.jobble_type_name = jt_find.name;
      _this.openingsList.value = _this.event.openings;
    }, 500);
  }

  set_openings() {
    var _this = this;
    let data = [];
    let openings_string = _this.event.openings.toString();
    let parent = {value: openings_string, values: []};
    try {
      for (var i = 0; i < 500; i++) {
        let new_data = {};
        new_data.value = (i + 1).toString();
        new_data.name = "opening-" + new_data.value;
        data.push(new_data);
      }
    } catch (err) {
      console.dir(err);
    }
    parent.values = data;
    _this.$timeout(function () {
      _this.openings_for_clone = parent;
    }, 300);
  }

  changed_clone_jobble_type() {
    var _this = this;
  }

  cloneInterval(ti) {
    var _this = this;
    console.log("cloneInterval");
    console.dir(ti);
    console.dir(_this.saving);

    if (_this.saving === false) {
      _this.saving = true;
      let newInterval = {};
      newInterval.contactInfo = {};
      newInterval.contactInfo.streetLine1 = ti.contactInfo.streetLine1;
      newInterval.contactInfo.state = ti.contactInfo.state;
      newInterval.contactInfo.city = ti.contactInfo.city;
      newInterval.contactInfo.zipCode = ti.contactInfo.zipCode;
      newInterval.contactInfo.lat = ti.contactInfo.lat;
      newInterval.contactInfo.lng = ti.contactInfo.lng;
      newInterval.address = ti.address;
      let add24hours = ti.startDateAndTimeMomentObj.add(24, "hours");
      newInterval.start_time = add24hours.format("hh:mm A");
      //newInterval.start_date = "Mar 25, 2020";
      newInterval.start_date = add24hours.format("MMM DD, YYYY");
      newInterval.hours = ti.hours;
      newInterval.minutes = ti.minutes;
      newInterval.endDateAndTimeMomentObj = ti.endDateAndTimeMomentObj;
      newInterval.startDateAndTimeMomentObj = ti.startDateAndTimeMomentObj;
      newInterval.durationInMinutes = ti.durationInMinutes;
      newInterval.durationInHours = ti.durationInHours;
      newInterval.startDateAndTimeForDB = "2020-03-25T21:30:00-04:00";
      newInterval.endDateAndTimeForDB = "2020-03-25T22:30:00-04:00";
      newInterval.cost = null;
      newInterval.isOverlapping = false;
      newInterval.isClone = true;
      //_this.event.timeIntervalsArray.push(newInterval)
      _this.currentTimeInterval = newInterval;
      _this.submitDateAndLocation();
    }
  }

  markAllShiftsAsNotBeingEdited() {
    var _this = this;
    _this.event.timeIntervalsArray.forEach(function (ti) {
      ti.isBeingEdited = false;
    });
  }

  cancelAddShift() {
    var _this = this;

    _this.step = 2;
    _this.markAllShiftsAsNotBeingEdited();
    _this.shiftIsBeingEdited = false;
  }

  checkGoogle() {
    var _this = this;
    console.log("check google");
    _this.$timeout(function () {
      _this.googleIsDoneLoading = true;
      _this.showDateAndTimeUI();
    }, 2000);
  }

  addressChanging() {
    var _this = this;
    console.log("addressChanging");
    console.dir(_this.currentTimeInterval.address);
    console.dir(_this.currentTimeInterval.address_temp);
    //.currentTimeInterval
  }

  go_to_bulk_upload_jobs_page() {
    this.$state.go("postjobbulk");
  }

  checkForAdmin() {
    console.log("checkForAdmin");

    var _this = this;

    if (_this.currentUser.username.indexOf("jobble.com") !== -1 || _this.currentUser.username.indexOf("jobbleapp.com") !== -1) {
      _this.currentUser.isAdmin = true;
    } else {
      _this.currentUser.isAdmin = false;
    }
  }
}

PosteventController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "$stateParams",
  "auth",
  "env",
  "teams",
  "companies",
  "security",
  "$filter",
  "events",
  "$timeout",
  "$location",
  "$rootScope",
  "$scope",
  "tracking",
];

export default PosteventController;



// WEBPACK FOOTER //
// ./client/app/components/postevent/postevent.controller.js